{
  "common": {
    "main": {
      "project": "Mradi",
      "form": "Fomu",
      "version": "Toleo",
      "formSettings": "Mipangilio ya fomu",
      "user": "Mtumiaji",
      "organization": "Shirika",
      "server": "Seva",
      "url": "URL"
    },
    "buttons": {
      "ok": "Sawa",
      "cancel": "Ghairi",
      "save": "Hifadhi",
      "add": "Ongeza",
      "edit": "Hariri",
      "delete": "Futa",
      "refresh": "Onyesha upya",
      "create": "Unda",
      "submit": "Wasilisha",
      "clear": "Futa",
      "selectAll": "Chagua kote",
      "back": "Rudi",
      "next": "Ifuatayo",
      "previous": "Iliyopita",
      "close": "Funga",
      "confirm": "Thibitisha",
      "yes": "Ndio",
      "no": "Hapana",
      "search": "Tafuta",
      "filter": "Chuja",
      "export": "Hamisha",
      "import": "Ingiza",
      "download": "Pakua",
      "upload": "Pakia",
      "view": "Tazama",
      "preview": "Hakikisha",
      "copy": "Nakili",
      "assign": "Agiza",
      "unassign": "Ondoa",
      "retry": "Jaribu tena",
      "loading": "Inapakia..."
    },
    "dialogs": {
      "cancel": "Ghairi",
      "close": "Funga",
      "confirm": "Thibitisha",
      "delete": "Futa",
      "save": "Hifadhi mabadiliko",
      "confirmTitle": "Thibitisha hatua",
      "unsavedChanges": {
        "title": "Mabadiliko hayajahifadhiwa",
        "message": "Kuna mabadiliko ambayo hayajahifadhiwa. Funga bila kuhifadhi?"
      }
    },
    "table": {
      "headers": {
        "name": "Jina",
        "description": "Maelezo",
        "statistics": "Takwimu",
        "status": "Hali",
        "actions": "Vitendo",
        "createdAt": "Tarehe ya kuunda",
        "updatedAt": "Tarehe ya kusasisha",
        "created": "Imeundwa",
        "updated": "Imesasishwa",
        "type": "Aina",
        "version": "Toleo",
        "id": "Kitambulisho",
        "email": "Barua pepe",
        "role": "Jukumu",
        "user": "Mtumiaji",
        "project": "Mradi",
        "organization": "Shirika",
        "lastSubmission": "Mwisho wa kusubiri",
        "server": "Seva",
        "url": "URL",
        "format": "Muundo",
        "count": "Hesabu",
        "size": "Ukubwa",
        "date": "Tarehe",
        "time": "Wakati",
        "severity": "Ukali",
        "field": "Uga Kuu",
        "form": "Fomu",
        "state": "Hali",
        "roles": "Jukumu",
        "groups": "Vikundi",
        "formId": "ID ya fomu",
        "permissions": "Ruhusa",
        "enabled": "Imeamilishwa",
        "disabled": "Imezimwa",
        "submissions": "Wasilishaji",
        "publishedAt": "Imechapishwa"
      },
      "pagination": {
        "page": "Ukurasa",
        "of": "ya",
        "perPage": "kwa ukurasa",
        "showing": "Inaonyesha",
        "to": "hadi",
        "totalEntries": "jumla ya maingizo",
        "resultsText": "matokeo.",
        "perPageText": "Matokeo kwa ukurasa"
      },
      "ariaLabels": {
        "viewDetails": "Tazama maelezo",
        "edit": "Hariri",
        "delete": "Futa",
        "previousPage": "Ukurasa uliopita",
        "nextPage": "Ukurasa unaofuata"
      }
    },
    "status": {
      "active": "Amilifu",
      "inactive": "Haitumiki",
      "archived": "Imehifadhiwa",
      "draft": "Rasimu",
      "published": "Imechapishwa",
      "pending": "Inasubiri",
      "completed": "Imekamilika",
      "failed": "Imeshindikana",
      "success": "Mafanikio",
      "error": "Kosa",
      "warning": "Onyo",
      "info": "Taarifa",
      "loading": "Inapakia",
      "notSet": "Haijawekwa",
      "notSpecified": "Haijabainishwa",
      "notAvailable": "Hapana",
      "unknown": "Haijulikani",
      "enabled": "Imeamilishwa",
      "disabled": "Imezimwa"
    },
    "messages": {
      "confirmDelete": "Je, una uhakika unataka kufuta",
      "confirmDeleteWithName": "Je, una uhakika unataka kufuta \"{name}\"?",
      "deleteSuccess": "Imefutwa kwa mafanikio",
      "deleteError": "Kosa katika kufuta",
      "saveSuccess": "Imehifadhiwa kwa mafanikio",
      "saveError": "Kosa katika kuhifadhi",
      "createSuccess": "Imeundwa kwa mafanikio",
      "createError": "Kosa katika kuunda",
      "updateSuccess": "Imesasishwa kwa mafanikio",
      "updateError": "Kosa katika kusasisha",
      "error": "Kosa",
      "loadError": "Kosa katika kupakia",
      "noData": "Hakuna data",
      "noResults": "Hakuna matokeo",
      "required": "Sehemu hii inahitajika",
      "invalidEmail": "Tafadhali ingiza barua pepe sahihi",
      "confirmDeleteWithType": "Je, una uhakika unataka kufuta \"{name}\" ({type})?",
      "bulkOperationSuccess": "Operesheni ya wingi imekamilika kwa mafanikio",
      "bulkOperationError": "Kosa katika kufanya operesheni ya wingi",
      "operationFailed": "Haikuweza kufanya operesheni",
      "unsavedChanges": "Fomu ina mabadiliko ambayo hayajahifadhiwa. Una uhakika unataka kuifunga?",
      "created": "imeundwa",
      "updated": "imesasishwa",
      "invalidUrl": "Please enter a valid URL"
    },
    "statistics": {
      "title": "Takwimu",
      "subtitle": "Tazama takwimu za shirika, hali ya fomu na kazi ya miradi.",
      "overall": "Takwimu za Jumla",
      "byState": "Fomu kwa Hali",
      "projectDetails": "Maelezo ya Mradi",
      "projectLedger": "Daftari la miradi",
      "pipeline": "Hali",
      "projectCount": "{count} miradi",
      "noActiveForms": "Hakuna fomu zilizotumika",
      "projects": "Miradi",
      "totalForms": "Jumla ya Fomu",
      "activeForms": "Fomu za Kikazi",
      "submissions": "Uwasilishaji",
      "forms": "Fomu",
      "lastUpdated": "Imesasishwa mwisho",
      "noDataToDisplay": "Hakuna data ya kuonyesha"
    },
    "viewMode": {
      "cards": "Kadi",
      "table": "Jedwali",
      "list": "Orodha",
      "grid": "Gridi"
    },
    "time": {
      "today": "leo",
      "yesterday": "jana",
      "thisWeek": "wiki hii",
      "lastWeek": "wiki iliyopita",
      "thisMonth": "mwezi huu",
      "lastMonth": "mwezi uliopita",
      "allTime": "wakati wote",
      "last7Days": "Siku 7 zilizopita",
      "last30Days": "Siku 30 zilizopita",
      "last90Days": "Siku 90 zilizopita",
      "customRange": "Masafa maalum",
      "startDate": "Tarehe ya kuanza",
      "endDate": "Tarehe ya kumaliza",
      "justNow": "Hivi sasa",
      "minutesAgo": "{count} dakika iliyopita",
      "hoursAgo": "{count} masaa iliyopita",
      "daysAgo": "{count} siku iliyopita",
      "never": "Kamwe"
    },
    "placeholders": {
      "enterName": "Ingiza jina",
      "enterDescription": "Ingiza maelezo",
      "enterEmail": "Ingiza barua pepe",
      "enterUrl": "Ingiza URL",
      "search": "Tafuta...",
      "selectOption": "Chagua chaguo"
    },
    "formState": {
      "title": "Badilisha Hali ya Fomu",
      "form": "Fomu",
      "currentStatus": "Hali ya sasa",
      "newStatus": "Hali mpya",
      "pleaseSelectStatus": "Tafadhali chagua hali",
      "statusChangedSuccessfully": "Hali ya fomu {formName} imebadilishwa kwa mafanikio kuwa {status}",
      "errorChangingStatus": "Hitilafu katika kubadilisha hali ya fomu"
    }
  },
  "admin": {
    "agent": {
      "title": "Hermes Agent",
      "subtitle": "Kujifunza na kujibu maswali kuhusu sheria za fomu, wasilisho, analitiki, sheria za QC, na hali ya sinkronizasyon. Majibu yanaweza kuwa na data ya kawaida; wasilisho wakati mmoja wanaweza kuwa na urefu wa kibinafsi.",
      "back": "Rudi kwenye dashboard",
      "health": {
        "title": "Hali ya kuunganisha",
        "checkNow": "Jaribu sasa",
        "latency": "Ucheleweshaji",
        "lastCheck": "Ukaguzi wa mwisho"
      },
      "stats": {
        "activeSubs": "Subskiripshoni inatumika",
        "requestsToday": "Wasilishaji wakati huu",
        "tokensToday": "Tokeni wakati huu",
        "nearQuota": "Orgs karibu na quota",
        "activeSubsHint": "jumla {total}",
        "nearQuotaHint": ">80% imetumika"
      },
      "config": {
        "title": "Mipangilio (sio ya kusasisha)"
      },
      "jobs": {
        "title": "Wafanyakazi za RQ (ripoti za analitiki)",
        "empty": "Hakuna kazi za hivi karibuni"
      },
      "digests": {
        "title": "Digests ya kusaidia",
        "trigger": "Jaribu kwao kwao",
        "historyTitle": "Hisaori ya digest",
        "historyEmpty": "Hakuna digest inayofanyika hivi sasa."
      },
      "selfHeal": {
        "title": "Wafanyakazi za kuendeshwa",
        "trigger": "Jaribu kwao kwao"
      },
      "incident": {
        "banner": "Ushirikiano wa Hermes au MCP sio mzuri. Vipengele vya wakala vinaweza kupunguzwa hadhi.",
        "title": "Inahitaji uangalizi"
      },
      "subscriptions": {
        "title": "Subskiripshoni za agenti",
        "subtitle": "Kujifunza na kujibu maswali kuhusu sheria za fomu, wasilisho, analitiki, sheria za QC, na hali ya sinkronizasyon. Majibu yanaweza kuwa na data ya kawaida; wasilisho wakati mmoja wanaweza kuwa na urefu wa kibinafsi.",
        "searchPlaceholder": "Tafuta shirika...",
        "allTiers": "Viwango vyote",
        "editTitle": "Hariri usajili",
        "resetTitle": "Weka upya matumizi",
        "resetMessage": "Weka upya vihesabu vya matumizi kwa {name}?",
        "resetConfirm": "Weka upya",
        "empty": "Hakuna usajili uliopatikana",
        "tierDefaultsTitle": "Chaguomsingi za viwango",
        "tierDefaultsHint": "Vikomo vya marejeleo kutoka backend SSOT. Kubadilisha kiwango katika fomu ya kuhariri kunatumia thamani hizi (ubadilishaji bado unawezekana).",
        "columns": {
          "org": "Shirika",
          "tier": "Kiwango",
          "fiveHour": "Saa 5",
          "week": "Wiki",
          "month": "Mwezi",
          "features": "Vipengele"
        },
        "tierDefaults": {
          "fiveHour": "Saa 5 (maombi / tokeni)",
          "week": "Wiki (maombi / tokeni)",
          "month": "Mwezi (maombi / tokeni)"
        }
      },
      "usage": {
        "title": "Kutumia agenti",
        "subtitle": "Hisaori ya kutumia agenti kwa shirika",
        "orgIdPlaceholder": "ID ya shirika",
        "allFeatures": "Vipengele vyote",
        "empty": "Hakuna matukio ya matumizi",
        "columns": {
          "time": "Muda",
          "org": "Shirika",
          "user": "Mtumiaji",
          "feature": "Kipengele",
          "tokens": "Tokeni"
        }
      },
      "audit": {
        "title": "Audit ya kutumia vifaa",
        "subtitle": "Hisaori ya kutumia vifaa (hasa vitendo vya kusasisha)",
        "orgIdPlaceholder": "ID ya shirika",
        "toolPlaceholder": "Jina la zana",
        "writeOnly": "Zana za kuandika pekee",
        "detailTitle": "Maelezo ya ukaguzi",
        "detail": "Maelezo",
        "empty": "Hakuna kumbukumbu za ukaguzi",
        "write": "Kuandika",
        "read": "Kusoma",
        "columns": {
          "time": "Muda",
          "org": "Shirika",
          "tool": "Zana",
          "write": "Kuandika"
        }
      },
      "sections": {
        "metrics": "Mapigo"
      }
    },
    "dialogs": {
      "deleteProject": {
        "title": "Futa proyekti",
        "message": "Hii inaweza kuwa haifanyika. Bofya \"Futa kwao kwao\" kuwa na kufuta.",
        "formsCount": "Fomu zinazofutwa: {count}",
        "confirm": "Futa kwao kwao"
      },
      "deleteOrganization": {
        "title": "Futa shirika",
        "message": "Hii inaweza kuwa haifanyika. Bofya \"Futa kwao kwao\" kuwa na kufuta.",
        "confirm": "Futa kwao kwao"
      },
      "deleteForm": {
        "title": "Futa fomu",
        "message": "Hii inaweza kuwa haifanyika. Bofya \"Futa kwao kwao\" kuwa na kufuta.",
        "confirm": "Futa kwao kwao"
      },
      "deleteUser": {
        "title": "Futa mtumiaji",
        "message": "Hii inaweza kuwa haifanyika. Bofya \"Futa kwao kwao\" kuwa na kufuta.",
        "confirm": "Futa kwao kwao"
      },
      "projectDetails": "Mradi: {name}",
      "organizationDetails": "Shirika: {name}",
      "formDetails": "Fomu: {name}",
      "userDetails": "Mtumiaji: {name}",
      "close": "Funga",
      "createUser": {
        "title": "Unda mtumiaji"
      },
      "editUser": {
        "title": "Hariri mtumiaji"
      },
      "fullName": "Jina fulani",
      "superuser": "Mtumiaji mkuu",
      "active": "Amilifu"
    },
    "back": "Rudi kwenye dashibodi",
    "chrome": {
      "sessionLabel": "Mtumiaji mkuu · vitendo vyote vinarekodiwa",
      "exit": "Toka kwenye hali",
      "menuTitle": "Usimamizi",
      "sessionWarning": "Kipindi cha msimamizi kitaisha baada ya {time}.",
      "extendSession": "Ongeza muda wa kipindi"
    },
    "nav": {
      "groups": {
        "overview": "Muhtasari",
        "directory": "Orodha",
        "access": "Ufikiaji",
        "integrations": "Miunganisho",
        "platform": "Jukwaa"
      },
      "dashboard": "Dashibodi",
      "analytics": "Uchanganuzi",
      "users": "Watumiaji",
      "organizations": "Mashirika",
      "projects": "Miradi",
      "forms": "Fomu",
      "roles": "Majukumu na ruhusa",
      "permissionGroups": "Vikundi vya ruhusa",
      "agent": "Hermes Agent",
      "agentDashboard": "Dashibodi ya ajenti",
      "agentSubscriptions": "Usajili wa ajenti",
      "agentUsage": "Matumizi ya ajenti",
      "agentAudit": "Ukaguzi wa ajenti",
      "globalOdk": "Seva za ODK za kimataifa",
      "system": "Mfumo",
      "audit": "Ukaguzi",
      "subscriptions": "Malipo"
    },
    "pagination": {
      "shown": "Inaonyesha {start} - {end} kati ya {total}",
      "pageOf": "Ukurasa {page} kati ya {pages}",
      "previous": "Iliyotangulia",
      "next": "Ifuatayo"
    },
    "common": {
      "tryAgain": "Jaribu tena",
      "showDeleted": "Onyesha zilizofutwa",
      "hideDeleted": "Ficha zilizofutwa",
      "showArchived": "Onyesha zilizohifadhiwa",
      "hideArchived": "Ficha zilizohifadhiwa",
      "allOrganizations": "Mashirika yote",
      "allProjects": "Miradi yote",
      "allRoles": "Majukumu yote",
      "allStatuses": "Hali zote",
      "totalRecords": "Jumla ya rekodi: {count}",
      "orgIdPrefix": "Shirika #{id}",
      "projectIdPrefix": "Mradi #{id}",
      "notSet": "Haijawekwa",
      "health": {
        "healthy": "Salama",
        "degraded": "Imedhoofika",
        "disabled": "Imezimwa",
        "unhealthy": "Si salama",
        "unknown": "Haijulikani"
      }
    },
    "pages": {
      "users": {
        "title": "Usimamizi wa watumiaji",
        "subtitle": "Tazama na simamia watumiaji wote wa mfumo",
        "addUser": "Ongeza mtumiaji",
        "searchPlaceholder": "Tafuta watumiaji...",
        "superuserBadge": "Mtumiaji mkuu",
        "userBadge": "Mtumiaji",
        "statsTotal": "Jumla",
        "statsSuperusers": "Watumiaji wakuu",
        "statsOwners": "Wamiliki",
        "statsActive": "Amilifu",
        "loadError": "Imeshindwa kupakia watumiaji",
        "empty": "Hakuna watumiaji wanaolingana na vichujio vya sasa"
      },
      "organizations": {
        "title": "Usimamizi wa mashirika",
        "subtitle": "Tazama na simamia mashirika yote ya mfumo",
        "searchPlaceholder": "Tafuta kwa jina la shirika au maelezo...",
        "sectionTitle": "Mashirika",
        "loading": "Inapakia mashirika...",
        "empty": "Hakuna mashirika yaliyopatikana",
        "loadError": "Imeshindwa kupakia mashirika",
        "restored": "Shirika limerejeshwa",
        "restoreError": "Imeshindwa kurejesha shirika",
        "owner": "Mmiliki",
        "created": "Imeundwa",
        "deletedBadge": "Imefutwa",
        "activeBadge": "Amilifu",
        "agentSubscription": "Usajili wa ajenti",
        "statsTotal": "Jumla ya mashirika",
        "statsActive": "Amilifu",
        "statsProjects": "Miradi",
        "statsForms": "Fomu"
      },
      "projects": {
        "title": "Usimamizi wa miradi",
        "subtitle": "Tazama na simamia miradi yote ya mfumo",
        "searchPlaceholder": "Tafuta kwa jina la mradi au maelezo...",
        "sectionTitle": "Miradi",
        "loading": "Inapakia miradi...",
        "empty": "Hakuna miradi iliyopatikana",
        "loadError": "Imeshindwa kupakia miradi",
        "archived": "Mradi umehifadhiwa kumbukumbu",
        "unarchived": "Mradi umetolewa kwenye kumbukumbu",
        "archiveError": "Imeshindwa kuhifadhi mradi kumbukumbu",
        "unarchiveError": "Imeshindwa kutoa mradi kwenye kumbukumbu",
        "created": "Imeundwa",
        "archivedBadge": "Imehifadhiwa",
        "activeBadge": "Amilifu",
        "statsTotal": "Jumla ya miradi",
        "statsActive": "Amilifu",
        "statsArchived": "Zilizohifadhiwa",
        "statsForms": "Fomu"
      },
      "forms": {
        "title": "Usimamizi wa fomu",
        "subtitle": "Tazama na simamia fomu zote za mfumo",
        "searchPlaceholder": "Tafuta kwa jina la fomu au XML ID...",
        "sectionTitle": "Fomu",
        "loading": "Inapakia fomu...",
        "empty": "Hakuna fomu zilizopatikana",
        "loadError": "Imeshindwa kupakia fomu",
        "deletedToast": "Fomu imewekwa alama ya kufutwa",
        "restoredToast": "Fomu imerejeshwa",
        "deleteError": "Imeshindwa kufuta fomu",
        "restoreError": "Imeshindwa kurejesha fomu",
        "created": "Imeundwa",
        "deletedBadge": "Imefutwa",
        "activeBadge": "Amilifu",
        "importedBadge": "Imeingizwa",
        "statsTotal": "Jumla ya fomu",
        "statsActive": "Amilifu",
        "statsDeleted": "Zilizofutwa",
        "statsImported": "Zilizoingizwa"
      },
      "permissionGroups": {
        "title": "Vikundi vya ruhusa",
        "subtitle": "Simamia vikundi vya ruhusa na uvikabidhi kwa watumiaji",
        "createGroup": "Unda kikundi",
        "sectionTitle": "Vikundi vya ruhusa",
        "searchPlaceholder": "Tafuta vikundi...",
        "emptyFilter": "Hakuna vikundi vinavyolingana na utafutaji wa sasa",
        "restoreError": "Imeshindwa kurejesha kikundi cha ruhusa",
        "deleteError": "Imeshindwa kufuta kikundi cha ruhusa",
        "emptyTitle": "Hakuna vikundi vya ruhusa vilivyopatikana",
        "emptyBody": "Unda kikundi cha kwanza cha ruhusa ili kuanza",
        "deleteTitle": "Futa kikundi",
        "deleteMessage": "Una uhakika unataka kufuta kikundi \"{name}\"? Kitendo hiki hakiwezi kutenduliwa.",
        "restoreTitle": "Rejesha",
        "users": "Watumiaji",
        "statsTotal": "Jumla ya vikundi",
        "statsActive": "Vikundi amilifu",
        "statsAssignments": "Ukabidhi",
        "loadError": "Imeshindwa kupakia vikundi vya ruhusa",
        "restored": "Kikundi \"{name}\" kimerejeshwa",
        "deleted": "Kikundi cha ruhusa kimefutwa",
        "saved": "Kikundi cha ruhusa kimehifadhiwa",
        "modal": {
          "createTitle": "Create permission group",
          "editTitle": "Edit permission group",
          "createHeader": "New permission group",
          "editHeader": "Edit group",
          "createSubtitle": "Create a new group with a set of roles",
          "editSubtitle": "Modify permission group parameters",
          "nameLabel": "Group name",
          "namePlaceholder": "Enter group name",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Enter group description",
          "activeLabel": "Group is active",
          "activeHint": "Inactive groups cannot be assigned to users",
          "rolesTitle": "Group roles",
          "rolesSubtitle": "Select roles to include in this group",
          "selectAtLeastOneRole": "Select at least one role",
          "selectedRolesTitle": "Selected roles",
          "clickToRemove": "Click on a role to remove it from the group",
          "validation": {
            "nameRequired": "Name is required",
            "nameMinLength": "Name must contain at least 2 characters",
            "nameMaxLength": "Name must not exceed 50 characters"
          },
          "toasts": {
            "createSuccess": "Permission group created successfully",
            "updateSuccess": "Permission group updated successfully",
            "saveError": "Error saving permission group"
          }
        },
        "groupUsersModal": {
          "title": "Users in group \"{name}\"",
          "noDescription": "No description available",
          "rolesCount": "Roles in group: {count}",
          "usersCount": "Users in group ({count})",
          "empty": "No users in this group",
          "noName": "Unnamed",
          "active": "Active",
          "inactive": "Inactive",
          "superuser": "Superuser",
          "owner": "Owner",
          "loadError": "Error loading group users"
        }
      },
      "globalOdkServers": {
        "title": "Seva za ODK za kimataifa",
        "subtitle": "Unda na simamia seva za ODK za mfumo mzima",
        "createServer": "Unda seva",
        "statsTotal": "Jumla ya seva",
        "statsTotalHint": "{count} (+{active} amilifu)",
        "statsGlobal": "Kimataifa",
        "statsDefault": "Chaguomsingi",
        "testTitle": "Matokeo ya jaribio la muunganisho",
        "testOk": "Muunganisho umefanikiwa",
        "testFail": "Muunganisho umeshindikana",
        "testMethod": "Njia:",
        "testProjects": "Idadi ya miradi:",
        "testing": "Inajaribu muunganisho...",
        "refreshTokenTitle": "Sasisha tokeni ya API",
        "refreshTokenBody": "Ingiza nenosiri ili kusasisha tokeni ya API ya seva",
        "password": "Nenosiri",
        "passwordPlaceholder": "Ingiza nenosiri",
        "refreshTokenAction": "Sasisha tokeni",
        "requiredField": "Sehemu hii inahitajika",
        "searchPlaceholder": "Tafuta kwa jina, URL, au jina la mtumiaji...",
        "empty": "Hakuna seva za ODK za kimataifa",
        "emptyHint": "Unda seva ya kwanza ya ODK ya kimataifa ili kuanza.",
        "emptyFilter": "Hakuna seva zinazolingana na utafutaji wa sasa",
        "defaultBadge": "Chaguomsingi",
        "columns": {
          "server": "Seva",
          "user": "Mtumiaji",
          "visibility": "Mwonekano"
        },
        "visibility": {
          "GLOBAL": "Kimataifa",
          "ORGANIZATION": "Shirika",
          "SHARED": "Imeshirikiwa"
        },
        "actions": {
          "test": "Jaribu muunganisho",
          "refreshToken": "Sasisha tokeni",
          "setDefault": "Weka kama chaguomsingi"
        },
        "deleteTitle": "Futa seva",
        "deleteMessage": "Futa seva \"{name}\"? Kitendo hiki hakiwezi kutenduliwa.",
        "setDefaultTitle": "Weka seva ya chaguomsingi",
        "setDefaultMessage": "Weka \"{name}\" kama seva ya ODK ya chaguomsingi ya kimataifa?",
        "setDefaultConfirm": "Weka chaguomsingi",
        "toastCreated": "Seva imeundwa",
        "toastUpdated": "Seva imesasishwa",
        "toastDeleted": "Seva imefutwa",
        "toastTestOk": "Muunganisho umefanikiwa",
        "toastTokenRefreshed": "Tokeni ya API imesasishwa",
        "toastDefaultSet": "Seva ya chaguomsingi ya kimataifa imesasishwa",
        "form": {
          "createTitle": "Create global ODK server",
          "editTitle": "Edit global ODK server",
          "nameLabel": "Server name",
          "namePlaceholder": "Enter server name",
          "urlLabel": "Server URL",
          "urlPlaceholder": "https://example.com",
          "usernameLabel": "Username",
          "usernamePlaceholder": "Enter username",
          "passwordLabel": "Password",
          "passwordPlaceholder": "Enter password",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Server description (optional)",
          "globalDefaultLabel": "Global default server",
          "activeLabel": "Active server",
          "updateButton": "Update"
        }
      },
      "subscriptions": {
        "title": "Usajili wa malipo",
        "subtitle": "Malipo ya SaaS na mipango ya malipo (si viwango vya Hermes Agent)",
        "stubBadge": "Inakuja hivi karibuni",
        "stubBody": "Usajili wa malipo unaendelezwa. Ukurasa huu utasimamia mipango ya kibiashara malipo yatakapozinduliwa.",
        "stubAgentHint": "Viwango, mgao, na vipengele vya Hermes Agent vinasimamiwa chini ya Miunganisho → Hermes Agent → Usajili.",
        "openAgentSubscriptions": "Fungua usajili wa ajenti",
        "billingNotice": "Usajili wa malipo unaendelezwa. Hapa chini kuna data halisi ya usajili na matumizi ya Hermes Agent.",
        "partialLoadError": "Imeshindwa kupakia baadhi ya data.",
        "agentSubs": "Usajili wa ajenti",
        "activeCount": "{count} amilifu",
        "requestsToday": "Maombi ya leo",
        "agentStatus": "Hali ya ajenti",
        "sectionTitle": "Usajili wa Hermes Agent",
        "sectionSubtitle": "Mashirika yenye ufikiaji wa muunganisho wa ajenti",
        "manageCta": "Simamia usajili",
        "empty": "Hakuna usajili uliopatikana",
        "tier": "Kiwango",
        "usage": "Matumizi",
        "resourcesTitle": "Matumizi ya rasilimali za mfumo",
        "orgs": "Mashirika",
        "projects": "Miradi",
        "forms": "Fomu",
        "submissions": "Mawasilisho"
      },
      "audit": {
        "title": "Ukaguzi wa vitendo",
        "subtitle": "Kumbukumbu ya vitendo vya usimamizi vya watumiaji wakuu",
        "loadError": "Imeshindwa kupakia kumbukumbu ya ukaguzi.",
        "empty": "Bado hakuna rekodi za ukaguzi",
        "time": "Muda",
        "user": "Mtumiaji",
        "action": "Kitendo",
        "details": "Maelezo",
        "emptyFilter": "Hakuna rekodi zinazolingana na utafutaji wa sasa",
        "searchPlaceholder": "Tafuta kwa mtumiaji, kitendo, au maelezo...",
        "actionKey": "Ufunguo wa kitendo",
        "detailTitle": "Rekodi ya ukaguzi"
      },
      "system": {
        "title": "Afya ya mfumo",
        "subtitle": "Uchunguzi wa miundombinu — hali, ucheleweshaji, na maelezo ya utendaji",
        "loadError": "Imeshindwa kupakia hali ya mfumo.",
        "serverInfo": "Maelezo ya utendaji",
        "version": "Toleo",
        "uptime": "Muda wa mchakato",
        "dbConnections": "Miunganisho ya DB (amilifu)",
        "dbPool": "Ukubwa wa dimbwi la DB",
        "components": {
          "server": "Seva",
          "database": "Hifadhidata",
          "redis": "Redis",
          "api": "API",
          "agent": "Hermes Agent"
        },
        "attentionTitle": "Inahitaji umakini",
        "attentionComponent": "{component}: {status}",
        "openAgent": "Fungua Ajenti",
        "componentsTitle": "Vijenzi",
        "dbLatency": "Ucheleweshaji wa DB",
        "apiLatency": "Ucheleweshaji wa API"
      },
      "analytics": {
        "title": "Dashibodi ya uchanganuzi",
        "subtitle": "Uchanganuzi wa mfumo mzima na watumiaji",
        "loadError": "Imeshindwa kupakia uchanganuzi. Inaonyesha thamani sifuri.",
        "totalUsers": "Jumla ya watumiaji",
        "thisMonth": "+{count} mwezi huu",
        "organizations": "Mashirika",
        "growthPct": "Ukuaji wa {pct}%",
        "totalProjects": "Jumla ya miradi",
        "totalForms": "Jumla ya fomu",
        "submissions": "Mawasilisho",
        "userGrowth": "Ukuaji wa watumiaji (kwa mwezi)",
        "orgActivity": "Shughuli za mashirika (kwa miradi)",
        "noData": "Hakuna data",
        "topOrgs": "Mashirika bora",
        "projectsCount": "Miradi {count}",
        "noOrgs": "Hakuna mashirika",
        "recentActivity": "Shughuli za hivi karibuni",
        "noRecent": "Hakuna shughuli za hivi karibuni",
        "systemHealth": "Afya ya mfumo",
        "resources": "Matumizi ya rasilimali",
        "orgs": "Mashirika",
        "projects": "Miradi",
        "forms": "Fomu",
        "health": {
          "api": "API",
          "database": "Hifadhidata",
          "redis": "Redis",
          "websocket": "WebSocket",
          "agent": "Hermes Agent"
        }
      },
      "roles": {
        "title": "Majukumu na ruhusa",
        "subtitle": "Katalogi ya majukumu ya jukwaa — vipande vya vikundi vya ruhusa",
        "searchPlaceholder": "Tafuta majukumu...",
        "loadError": "Imeshindwa kupakia majukumu.",
        "emptyTitle": "Hakuna majukumu yaliyopatikana",
        "emptyFilter": "Hakuna majukumu yanayolingana na utafutaji",
        "openGroups": "Vikundi vya ruhusa",
        "system": "Mfumo",
        "custom": "Maalum",
        "unused": "Haitumiki katika kikundi chochote",
        "columns": {
          "role": "Jukumu",
          "description": "Maelezo",
          "usedIn": "Inatumika katika vikundi",
          "type": "Aina"
        },
        "labels": {
          "project_member": "Mwanachama wa mradi"
        },
        "descriptions": {
          "fallback": "Hakuna maelezo yanayopatikana.",
          "manager": "Usimamizi kamili wa mradi na usimamizi wa ubora.",
          "project_member": "Ufikiaji mdogo wa mradi — jina na fomu, bila data ya uwasilishaji.",
          "data_viewer": "Ufikiaji wa kusoma tu kwa uwasilishaji, ufuatiliaji na ukaguzi wa QC.",
          "data_collector": "Kukusanya na kuwasilisha data ya uwandani.",
          "data_downloader": "Kusafirisha na kupakua data ya uwasilishaji.",
          "data_analyst": "Operesheni za QC na uchambuzi wa data.",
          "form_designer": "Kuunda na kusimamia fomu za XLSForm.",
          "qc_editor": "Kuhariri matokeo na matokeo ya QC."
        }
      }
    },
    "dashboard": {
      "title": "Muhtasari",
      "subtitle": "Mapigo ya jukwaa na shughuli za hivi karibuni za msimamizi",
      "errors": {
        "stats": "Haikuweza kupakia vipimo vya mfumo. Inaonyesha sifuri.",
        "health": "Haikuweza kupakia afya ya mfumo.",
        "activities": "Haikuweza kupakia shughuli za hivi karibuni."
      },
      "attention": {
        "title": "Inahitaji umakini",
        "server": "Seva inaripoti hali isiyo salama.",
        "database": "Hifadhidata inaripoti hali isiyo salama.",
        "redis": "Redis inaripoti hali isiyo salama.",
        "api": "API inaripoti hali isiyo salama.",
        "agent": "Hali ya Hermes Agent: {status}.",
        "failedLogins": "Majaribio {count} ya kuingia yaliyoshindikana katika saa 24 zilizopita.",
        "openSystem": "Fungua Mfumo",
        "openAgent": "Fungua Ajenti",
        "openAudit": "Fungua Ukaguzi"
      },
      "sections": {
        "metrics": "Orodha",
        "health": "Afya",
        "activity": "Shughuli za hivi karibuni"
      },
      "metrics": {
        "users": "Watumiaji",
        "usersHint": "+{count} leo",
        "orgs": "Mashirika",
        "orgsHint": "+{count} wiki hii",
        "projects": "Miradi",
        "projectsHint": "{count} amilifu",
        "failedLogins": "Kuingia kulikoshindikana",
        "failedLoginsHint": "Saa 24 zilizopita"
      },
      "health": {
        "server": "Seva",
        "database": "Hifadhidata",
        "redis": "Redis",
        "api": "API",
        "agent": "Hermes Agent",
        "connections": "Miunganisho {count}",
        "latency": "{ms} ms",
        "agentHint": "Maombi {count} leo"
      },
      "activity": {
        "viewAll": "Tazama ukaguzi",
        "empty": "Hakuna shughuli za hivi karibuni za msimamizi"
      }
    }
  },
  "agent": {
    "common": {
      "loading": "Inapakia subskiripshoni ya agenti...",
      "working": "Agenti inaendeshwa..."
    },
    "features": {
      "reports": "Ripoti",
      "qc": "Assistant QC",
      "xlsform": "XLSForm",
      "share_links": "Share links",
      "auto_reports": "Auto-reports",
      "qc_rules": "QC rules"
    },
    "errors": {
      "generic": "Imeshindwa kutumia agenti.",
      "endpointNotFound": "Kipengele hiki kinahitaji backend mpya. Anzisha upya seva ya backend (.\\scripts\\dev.ps1).",
      "timeout": "Ajenti hakujibu kwa wakati. Msaidizi wa XLSForm anaweza kuchukua hadi dakika 10 — jaribu tena.",
      "featureUnavailable": "Hili inapaswa kuwa na kwa plani yako.",
      "quotaExceeded": "Kwao kwa quota ya agenti kwa mwaka huu.",
      "disabled": "Agenti AI inaweza kusitishwa kwa wakati mmoja.",
      "mcpUnavailable": "Hermes hakutazama udacapi MCP tools. Inaweza kutumia CT253 (grant-udacapi-mcp.sh) kuongeza MCP na kuthibitisha relay :8101 → backend :8100. Tazama runbooks/hermes-udacapi-agent-integration.md."
    },
    "quota": {
      "exceededTitle": {
        "monthly": {
          "requests": "Kiwango cha mwezi cha maombi kimefikiwa",
          "tokens": "Kiwango cha mwezi cha tokeni kimefikiwa"
        },
        "five_hour": {
          "requests": "Kiwango cha maombi cha saa 5 kimefikiwa",
          "tokens": "Kiwango cha tokeni cha saa 5 kimefikiwa"
        },
        "weekly": {
          "requests": "Kiwango cha wiki cha maombi kimefikiwa",
          "tokens": "Kiwango cha wiki cha tokeni kimefikiwa"
        }
      },
      "usageLine": "{used} kati ya {limit} imetumika",
      "resetsAt": "Inapatikana tena {relative} ({absolute})",
      "resetsUnknown": "Jaribu tena baadaye au wasiliana na admini yako kuongeza kiwango cha kura.",
      "viewSubscription": "Angalia maelezo ya quota",
      "sendBlocked": "Quota ya agenti imeisha — subiri hadi kiwango kirekebishwe.",
      "nearLimit": "Quota ya agenti karibu kuisha ({pct}%)."
    },
    "upgrade": {
      "lockedTitle": "Hili inapaswa kuwa na kwa plani yako.",
      "lockedDescription": "\"{feature}\" inapaswa kuwa na kwa plani {tier} na juu."
    },
    "subscription": {
      "sectionTitle": "Agenti AI",
      "sectionDescription": "Tier, quota na vikwazo vya agenti za shirika yako.",
      "currentTier": "Tier ya sasa",
      "active": "Inatumika",
      "inactive": "Haifanyi Kazi",
      "features": "Vikwazo vya inatumika",
      "tier": "Kiwango",
      "capabilities": "Uwezo",
      "billingPeriod": "Mwanzo wa kipindi cha malipo",
      "requests": "Wasilishaji wakati huu",
      "requests_5h": "Wasilishaji (muda 5 h)",
      "requests_weekly": "Wasilishaji (wiki 7 siku)",
      "requests_badge": "wsh.",
      "requests_5h_badge": "wsh. (5h)",
      "requests_weekly_badge": "wsh. (wiki 7 siku)",
      "tokens": "Tokeni huu mwezi",
      "tokens_5h": "Tokeni (muda 5 h)",
      "tokens_weekly": "Tokeni (wiki 7 siku)",
      "nearQuotaTitle": "Quota ya kiwango cha kura",
      "nearQuotaDescription": "Zaidi ya 80% ya quota ya mwezi inatumika. Fanya msaada na admini yako kuongeza kiwango cha kura.",
      "tiers": {
        "free": "Bure",
        "pro": "Mpya",
        "enterprise": "Jinsi"
      },
      "trialActive": "Pro trial active until {date}. After that you stay on Free with plan limits.",
      "submissionsSoftExceeded": "Submission volume is above your plan soft limit. Contact us to upgrade — field sync is not blocked."
    },
    "report": {
      "title": "Ripoti ya AI kwa PM",
      "description": "Ripoti ya kusumbua kwa UDA AI agenti.",
      "period": "Mwaka (siku)",
      "generate": "Unda ripoti",
      "generating": "Agenti inaendeshwa kuundwa ripoti...",
      "empty": "Bofya \"Unda ripoti\" kuwa na kusumbua.",
      "modeSummary": "Kusumbua",
      "modeAnalytical": "Kusumbua",
      "quotaExceeded": "Kwao kwa quota ya agenti kwa mwaka huu.",
      "featureUnavailable": "Ripoti AI haifanyi kuwa na kwa plani yako.",
      "error": "Imeshindwa kupakia ripoti kwa agenti.",
      "healthAlerts": "Maelezo ya hali ya fomu",
      "copy": "Nakili ripoti",
      "copied": "Imekosa",
      "copyFailed": "Imeshindwa kunakili ripoti kwa clipboard.",
      "viewFormatted": "Muundo",
      "viewRaw": "Markdown",
      "templates": {
        "title": "Violezo vya ripoti",
        "subtitle": "Sanidi maagizo ya ripoti za AI zilizoratibiwa na za mahitaji kwa shirika hili.",
        "create": "Kiolezo kipya",
        "createTitle": "Unda kiolezo cha ripoti",
        "edit": "Hariri",
        "editTitle": "Hariri kiolezo cha ripoti",
        "formSubtitle": "Bainisha ripoti inahusu nini, inaendeshwa lini na nani anaipokea.",
        "sections": {
          "content": "Maudhui ya ripoti",
          "schedule": "Ratiba",
          "delivery": "Utumaji na wigo"
        },
        "seed": "Pakia chaguomsingi",
        "seeded": "Violezo {count} vimepakiwa.",
        "empty": "Bado hakuna violezo. Pakia chaguomsingi au unda kimoja.",
        "active": "Amilifu",
        "inactive": "Haitumiki",
        "cron": "Ratiba",
        "sendByEmail": "Tuma kwa barua pepe",
        "deactivate": "Zima",
        "deactivated": "Kiolezo kimezimwa.",
        "activate": "Amilisha",
        "activated": "Kiolezo kimeamilishwa.",
        "save": "Hifadhi",
        "saved": "Kiolezo kimehifadhiwa.",
        "saveError": "Haikuweza kuhifadhi kiolezo.",
        "loadError": "Haikuweza kupakia violezo vya ripoti.",
        "validationRequired": "Jina na agizo vinahitajika.",
        "recipientsPlaceholder": "Chagua washiriki wa shirika",
        "recipientsRequired": "Chagua angalau mpokeaji mmoja ikiwa barua pepe imewezeshwa.",
        "promptHint": "Ufikiaji wa data ya shirika, fomu zilizochaguliwa na kipindi cha ripoti huongezwa kiotomatiki.",
        "allFormsPlaceholder": "Fomu zote (acha wazi)",
        "advancedMode": "Agizo maalum (la kina, Jinja2)",
        "fields": {
          "name": "Jina",
          "audience": "Hadhira",
          "prompt": "Maelekezo ya ripoti",
          "responseLanguage": "Lugha ya majibu",
          "recipients": "Wapokeaji",
          "formScope": "Fomu"
        },
        "schedule": {
          "label": "Ratiba",
          "none": "Hakuna ratiba",
          "daily": "Kila siku",
          "weekly": "Kila wiki",
          "monthly": "Kila mwezi",
          "custom": "Maalum (cron)",
          "time": "Saa",
          "weekday": "Siku ya wiki",
          "dayOfMonth": "Siku ya mwezi",
          "customCron": "Usemi wa cron",
          "humanDaily": "Kila siku saa {time}",
          "humanWeekly": "Kila {weekday} saa {time}",
          "humanMonthly": "Kila mwezi siku ya {day} saa {time}",
          "weekdays": {
            "0": "Jumapili",
            "1": "Jumatatu",
            "2": "Jumanne",
            "3": "Jumatano",
            "4": "Alhamisi",
            "5": "Ijumaa",
            "6": "Jumamosi"
          }
        },
        "audience": {
          "pm": "Meneja wa mradi",
          "field_coord": "Mratibu wa uwandani",
          "statistician": "Mtakwimu",
          "executive": "Mtendaji"
        }
      },
      "modeScheduled": "Iliyoratibiwa",
      "auto": {
        "latest": "Ya hivi karibuni",
        "history": "Historia",
        "generateNow": "Tengeneza sasa",
        "manageTemplates": "Simamia violezo",
        "selectTemplate": "Kiolezo",
        "latestEmpty": "Bado hakuna ripoti za violezo zilizokamilika. Chagua kiolezo kisha bofya Tengeneza sasa.",
        "historyEmpty": "Bado hakuna ripoti zilizoendeshwa.",
        "view": "Tazama",
        "viewTitle": "Ripoti",
        "close": "Funga",
        "generating": "Inatengeneza ripoti iliyoratibiwa...",
        "done": "Ripoti iko tayari.",
        "statusLabel": "Hali: {status}",
        "emptyResult": "Ripoti imekamilika lakini haikurudisha maudhui.",
        "runFailed": "Utengenezaji wa ripoti umeshindikana.",
        "timeout": "Ripoti imechukua muda mrefu sana. Jaribu tena baadaye.",
        "noContent": "Hakuna maudhui ya ripoti yanayopatikana.",
        "unknownTemplate": "Kiolezo kisichojulikana",
        "trigger": {
          "scheduled": "Iliyoratibiwa",
          "event": "Tukio",
          "manual": "Mwenyewe"
        },
        "status": {
          "pending": "Inasubiri",
          "running": "Inaendesha",
          "done": "Imekamilika",
          "failed": "Imeshindikana"
        }
      }
    },
    "chat": {
      "modeAsk": "Kutuma maswali kwa agenti",
      "description": "Kutuma maswali kuhusu sheria ya fomu, wasilisho, analitiki, sheria za QC, na hali ya sinkronizasyon. Majibu yanaweza kuwa na data ya kawaida; wasilisho wakati mmoja wanaweza kuwa na urefu wa kibinafsi.",
      "question": "Maswali yako",
      "placeholder": "k.m. Mawasilisho mangapi katika siku 7 zilizopita? Fomu hii ina sehemu gani?",
      "send": "Tuma",
      "empty": "Kutuma maswali kuhusu data ya fomu hiki.",
      "you": "Wewe",
      "agent": "Agenti",
      "generating": "Agenti inaendeshwa kupakia data ya fomu...",
      "sendHint": "Enter kutuma · Shift+Enter kwa mstari mpya"
    },
    "analytical": {
      "generate": "Kuanza ripoti analitiki",
      "empty": "Kuanza ripoti analitiki kuhusu analitiki ya fomu.",
      "queued": "Ripoti inaendeshwa...",
      "status": "Hali: {status}",
      "done": "Ripoti ready.",
      "failed": "Imeshindwa kuundwa ripoti analitiki.",
      "emptyResult": "Ripoti inaendeshwa lakini hakutumia maudhui.",
      "timeout": "Ripoti analitiki inaendeshwa lakini hakutumia wakati mmoja. Tazama kuwa agenti inaendeshwa kuundwa ripoti.",
      "workerHint": "Kazi inaendeshwa lakini hakutumia wakati mmoja. Kuanza usaidizi agent-reports-worker (docker compose up -d agent-reports-worker) na jaribu tena."
    },
    "qc": {
      "title": "Assistant QC AI",
      "description": "Soma kuhusu uthibitishaji kwa lugha rahisi — agenti inaendeshwa kutafuta sheria za QC.",
      "checkDescription": "Maelezo ya uthibitishaji",
      "checkPlaceholder": "e.g. umri wa mtazamaji inaweza kuwa kati ya 18 na 65",
      "suggest": "Suggua sheria",
      "generating": "Agenti inaendeshwa kutafuta sheria...",
      "applyDraft": "Inaendeshwa rasimu kwa fomu",
      "draftApplied": "Rasimu inaendeshwa kwa fomu ya sheria.",
      "draftPreview": "Sheria sugge",
      "viewRawResponse": "Tazama majibu fulani ya agenti",
      "sendHint": "Enter kupendekeza · Shift+Enter kwa mstari mpya",
      "noDraftParsed": "Imeshindwa kuparse JSON rasimu kwa sheria kwa majibu ya agenti.",
      "validationWarnings": "Maelezo ya uthibitishaji ({count}):",
      "starterPack": {
        "title": "Sheria za QC za kuanza",
        "description": "Tazama fomu na kupata seti ya sheria suggezu kuanza uthibitishaji.",
        "focus": "Kusambaza",
        "focusAll": "Kikomo kikali",
        "focusRequired": "Uga kuu zinahitajika tu",
        "focusConstraints": "Kikomo zinahitajika tu",
        "maxRules": "Sheria maksimum",
        "suggest": "Suggua sheria za kuanza",
        "generating": "Tazama fomu na kutafuta sheria...",
        "apply": "Inaendeshwa sheria hii",
        "empty": "Hakuna rasimu ya sheria halali zimefanyika. Jaribu tena au kutumia suggezi ya sheria moja juu.",
        "skippedHint": "{count} sheria suggezu zimefikishwa (kupanuka, haifanyika, au kwao kwa kiwango cha kura)."
      }
    },
    "xlsform": {
      "openButton": "XLSForm AI",
      "title": "Assistant AI XLSForm",
      "description": "Pakia faili ya maswali au soma kuhusu taarifa — agenti inaendeshwa kutafuta sheria za QC.",
      "instruction": "Taarifa kwa agenti",
      "instructionPlaceholder": "e.g. kuanza fomu ya sura ya kusubiri 5 maswali",
      "empty": "Soma kuhusu fomu unayotaka au pakia faili — agenti inaendeshwa kutafuta sheria za QC.",
      "send": "Tuma",
      "sendHint": "Enter — tuma · Shift+Enter — kuongeza kipindi mpya",
      "working": "Agenti inaendeshwa kuendeshwa taarifa...",
      "you": "Wewe",
      "agent": "Agenti",
      "publishTitle": "Thibitisha chapishaji",
      "publishDescription": "Agenti inaendeshwa kutafuta chapishaji. Thibitisha kwao kwao — chapishaji haifanyi kuendeshwa bila thibitishaji.",
      "formId": "ID ya fomu (xmlFormId)",
      "versionOptional": "Toleo (iliyopatikana)",
      "confirmPublish": "Thibitisha chapishaji",
      "upload": {
        "hint": "Piga Excel/CSV, Word, au texti na maswali yako (max 5 MB)",
        "attachAria": "Piga faili",
        "removeAttachment": "Ondoa kiambatisho",
        "selected": "Faili: {name}",
        "attachmentPrefix": "[faili: {name}]"
      },
      "session": {
        "resumeBanner": "Una sesi ya AI XLSForm (rasimu: {formId})",
        "resumeButton": "Endesha",
        "startNewButton": "Anza upya",
        "dismissButton": "Ondoa",
        "dismissError": "Haikuweza kuondoa sesi. Jaribu tena.",
        "historyButton": "Sesi za zamani",
        "historyTitle": "Sesi za AI XLSForm",
        "historyHint": "Sesi za siku 7 zilizopita. Endelea rasimu au angalia sesi iliyochapishwa.",
        "historyEmpty": "Hakuna sesi za zamani kwa mradi huu.",
        "historyFormColumn": "Rasimu",
        "historyStatusColumn": "Hali",
        "historyUpdatedColumn": "Imesasishwa",
        "historyMessagesColumn": "Ujumbe",
        "historyActionsColumn": "Vitendo",
        "continueButton": "Endelea",
        "viewButton": "Angalia",
        "continueError": "Haikuweza kuendelea sesi. Jaribu tena.",
        "readOnlyHint": "Sesi hii ilichapishwa. Unaweza kuona historia lakini huwezi kutuma ujumbe mpya.",
        "draftUnknown": "kinajina",
        "status": {
          "active": "Hai",
          "discarded": "Imefutwa",
          "failed": "Imeshindwa",
          "published": "Imechapishwa"
        },
        "historyAriaLabel": "Historia ya vipindi",
        "historyPreviewColumn": "Maelezo ya hivi karibuni",
        "clearDismissedButton": "Futa zilizoachwa",
        "clearFailedButton": "Futa zilizoshindikana",
        "clearNonPublishedButton": "Futa zisizochapishwa",
        "cleanupError": "Haikuweza kufuta vipindi vya awali. Jaribu tena.",
        "forkedFrom": "Imetenganishwa kutoka toleo la awali",
        "lineagePublished": "Toleo lililochapishwa",
        "cleanupConfirm": {
          "dismissed": {
            "title": "Futa vipindi vilivyoachwa?",
            "message": "Hii inafuta kabisa vipindi vilivyoachwa vya mradi huu. Vipindi vilivyochapishwa vinabaki."
          },
          "failed": {
            "title": "Futa vipindi vilivyoshindikana?",
            "message": "Hii inafuta kabisa vipindi vilivyoshindikana vya mradi huu."
          },
          "non_published": {
            "title": "Futa vipindi vyote visivyochapishwa?",
            "message": "Hii inafuta kabisa vipindi amilifu, vilivyoachwa, na vilivyoshindikana. Vipindi vilivyochapishwa vinabaki."
          }
        }
      },
      "job": {
        "canClose": "Unaweza kufuata leo hili — sesi yako inaendeshwa kwa njia ya chini.",
        "elapsed": "Inaendeshwa… {time}",
        "agentWorking": "Agenti inaendeshwa kusaidia taarifa yako (LLM na vifaa vya MCP). Hii hatua inaendeshwa kwa wakati mmoja.",
        "longWait": "Inaendeshwa lakini hakutumia wakati mmoja. Tazama kuwa LLM proxy na Hermes MCP relay inaendeshwa kwa wakati mmoja.",
        "timeout": "Msaidizi wa fomu hakumaliza kwa wakati. Kikao kilichoshindwa kimewekwa upya; jaribu tena katika kikao kipya.",
        "failed": "Assistant XLSForm haifanyi kusaidia taarifa yako. Jaribu tena.",
        "phases": {
          "queued": "Inaendeshwa...",
          "planning": "Inaendeshwa taarifa yako",
          "editing": "Inaendeshwa maswali ya fomu",
          "uploading_draft": "Inaendeshwa fomu rasimu",
          "testing_draft": "Inaendeshwa fomu rasimu",
          "finalizing": "Inaendeshwa fomu rasimu",
          "completed": "Imekamilika"
        },
        "queuedFallback": "Wafanyakazi haifanyi kuchagua kazi hili — server inaendeshwa kujaribu kwa njia ya chini baada ya wakati mmoja."
      },
      "preview": {
        "tabChat": "Gumzo",
        "tabPreview": "Hakikisho",
        "loading": "Inapakia hakikisho la fomu…",
        "empty": "Hakuna rasimu ya hakikisho bado. Mwombe msaidizi kuunda au kuhariri fomu.",
        "error": "Haikuweza kupakia hakikisho la fomu.",
        "submitError": "Haikuweza kutuma uwasilishaji wa jaribio."
      },
      "workbench": {
        "tabChat": "Mazungumzo",
        "tabPreview": "Hakikisho",
        "downloadDraft": "Pakua rasimu",
        "downloadPublished": "Pakua iliyochapishwa",
        "uploadExcel": "Pakia Excel",
        "uploadConfirmTitle": "Badilisha fomu kutoka Excel?",
        "uploadConfirmMessage": "Hii itabadilisha maswali ya rasimu ya sasa na lahajedwali iliyopakiwa.",
        "uploadConfirmDetail": "Historia ya kipindi cha msaidizi inabaki; muundo wa fomu pekee ndio unaobadilika.",
        "startRevision": "Anza marekebisho",
        "openForm": "Fungua fomu katika mradi",
        "downloadError": "Haikuweza kupakua faili la Excel.",
        "importError": "Haikuweza kuingiza faili la Excel.",
        "forkError": "Haikuweza kuanza kipindi cha marekebisho."
      },
      "settings": {
        "title": "Mipangilio ya fomu",
        "hint": "Form ID inakuwa xmlFormId ya ODK. Lazima iwe ya kipekee katika mradi huu. Epuka kuibadilisha baada ya kuchapisha.",
        "formTitle": "Kichwa cha fomu",
        "formId": "Form ID (xmlFormId)",
        "save": "Hifadhi mipangilio",
        "saved": "Mipangilio imehifadhiwa",
        "conflict": "Form ID hii tayari inatumika katika mradi.",
        "suggestion": "Jaribu: {id}",
        "saveError": "Haikuweza kuhifadhi mipangilio ya fomu.",
        "saveBusy": "Haikuweza kuhifadhi wakati kazi ya ajenti inashikilia rasimu. Subiri kazi ikamilike, au jaribu tena."
      },
      "header": {
        "newForm": "Fomu mpya",
        "version": "Spec v{version}",
        "status": {
          "idea": "Kupanga",
          "draft": "Rasimu iko tayari",
          "publish": "Inasubiri kuchapishwa",
          "published": "Imechapishwa",
          "conflict": "Inahitaji umakini",
          "failed": "Imeshindikana"
        }
      },
      "timeline": {
        "title": "Matukio ya mfumo"
      },
      "changes": {
        "title": "Muhtasari wa mabadiliko"
      },
      "validation": {
        "title": "Uthibitishaji",
        "empty": "Uthibitishaji utaonekana baada ya usasishaji wa kwanza wa rasimu.",
        "noIssues": "Hakuna masuala yanayozuia yaliyogunduliwa.",
        "applySuggestedId": "Tumia ID iliyopendekezwa",
        "editSettings": "Hariri mipangilio",
        "status": {
          "ok": "Sawa",
          "warning": "Onyo",
          "error": "Kosa"
        }
      },
      "recovery": {
        "retryLast": "Jaribu tena ombi la mwisho",
        "startFresh": "Anza kipindi kipya"
      }
    },
    "entitlement": {
      "title": "Upgrade required",
      "body": "This capability is not included in your current organization plan. Contact us to upgrade to Pro or Enterprise.",
      "contactUs": "Contact us to upgrade your plan."
    }
  },
  "websocket": {
    "notifications": {
      "syncComplete": "Urekebishaji umekamilika: {formName}. {count} ya {total} rekodi zimechakatwa",
      "syncError": "Hitilafu ya urekebishaji: {formName}. {error}",
      "formStatusChange": "Hali ya fomu imebadilishwa: {formName} ({oldStatus} → {newStatus})",
      "schedulerUpdate": "Mpanga: {status}. Kazi za kazi: {activeJobs}/{totalJobs}",
      "qcValidationComplete": "Uthibitishaji QC umekamilika: {instanceId}. Sheria: {totalRules}, zilizopita: {passedRules}, makosa: {errorRules}, onyo: {warningRules}",
      "projectStatusSummary": "Mabadiliko muhimu: {errorProjects} miradi na makosa, {errorForms} fomu na makosa kati ya {totalProjects} miradi na {totalForms} fomu"
    },
    "connection": {
      "connected": "WebSocket imeunganishwa",
      "disconnected": "WebSocket imekatwa",
      "reconnecting": "Inaunganisha tena...",
      "error": "Hitilafu ya WebSocket: {error}",
      "maxRetriesReached": "Idadi ya juu ya majaribio ya kuunganisha tena imefikiwa"
    },
    "connected": "Imeunganishwa",
    "disconnected": "Imeakatwa",
    "realTimeUpdates": "Masasisho ya wakati halisi"
  },
  "buttonSelect": {
    "dark": "Giza",
    "light": "Mwanga"
  },
  "odkOptions": {
    "themes": {
      "light": "Angavu",
      "dark": "Giza"
    },
    "navigation": {
      "swipe": "Kutelezesha",
      "buttons": "Vitufe",
      "swipe_buttons": "Kutelezesha + Vitufe"
    },
    "formUpdate": {
      "manual": "Mwenyewe",
      "previously_downloaded": "Zilizopakuliwa awali",
      "match_exactly": "Linganisha kikamilifu"
    },
    "periodicUpdates": {
      "every_fifteen_minutes": "Kila dakika 15",
      "every_one_hour": "Kila saa 1",
      "every_six_hours": "Kila saa 6",
      "every_24_hours": "Kila saa 24"
    },
    "autosend": {
      "off": "Imezimwa",
      "wifi_only": "Wi‑Fi pekee",
      "cellular_only": "Data ya simu pekee",
      "wifi_and_cellular": "Wi‑Fi na data ya simu"
    },
    "constraintBehavior": {
      "on_swipe": "Wakati wa kutelezesha",
      "on_finalize": "Wakati wa kukamilisha"
    },
    "imageSizes": {
      "original": "Asili",
      "very_small": "Ndogo sana",
      "small": "Ndogo",
      "medium": "Wastani",
      "large": "Kubwa"
    },
    "guidanceHint": {
      "no": "Hapana",
      "yes": "Ndiyo",
      "yes_collapsed": "Ndiyo (imekunjwa)"
    },
    "basemap": {
      "google": "Google",
      "mapbox": "Mapbox",
      "osm": "OSM",
      "usgs": "USGS",
      "carto": "Carto"
    },
    "mapStyles": {
      "normal": "Kawaida",
      "terrain": "Ardhi",
      "hybrid": "Mseto",
      "satellite": "Setilaiti",
      "light": "Angavu",
      "dark": "Giza",
      "satellite_streets": "Setilaiti + mitaa",
      "outdoors": "Nje",
      "topographic": "Topografia",
      "positron": "Positron",
      "dark_matter": "Dark matter"
    },
    "fontSizes": {
      "small": "Ndogo",
      "normal": "Kawaida",
      "large": "Kubwa",
      "xl": "XL",
      "xxl": "XXL"
    }
  },
  "users": {
    "title": "Usimamizi wa Watumiaji",
    "subtitle": "Dhibiti wanachama wa shirika, chuja kulingana na shughuli na usasishe rekodi za ufikiaji.",
    "searchUser": "Tafuta mtumiaji",
    "addUser": "Ongeza mtumiaji",
    "editUser": "Hariri mtumiaji",
    "deleteUser": "Futa mtumiaji",
    "firstName": "Jina la kwanza",
    "lastName": "Jina la familia",
    "fullName": "Jina kamili",
    "email": "Barua pepe",
    "password": "Nenosiri",
    "confirmPassword": "Thibitisha nenosiri",
    "enterEmail": "Ingiza barua pepe",
    "userCreated": "Mtumiaji ameundwa kwa mafanikio",
    "userUpdated": "Mtumiaji amesasishwa kwa mafanikio",
    "userDeleted": "Mtumiaji amefutwa kwa mafanikio",
    "confirmDeleteUser": "Una uhakika unataka kufuta mtumiaji huyu?",
    "projectSelection": {
      "archived": "Imejiriwa",
      "noProjects": "Hakuna miradi zilizopatikana",
      "noProjectsDescription": "Hakuna miradi zilizopatikana kwa kuweka vikundi vya ruhusa",
      "errorLoadingProjects": "Hitilafu katika kupakia miradi"
    },
    "admin": "Msimamizi",
    "data_collector": "Mkusanyaji Data",
    "supervisor": "Msimamizi",
    "user": "Mtumiaji",
    "owner": "Mmiliki",
    "isClient": "Mtumiaji wa Kliki",
    "active": "Hai",
    "inactive": "Haifanyi kazi",
    "refresh": "Sasisha",
    "unsavedChanges": "Fomu ina mabadiliko ambayo hayajahifadhiwa. Una uhakika unataka kuifunga?",
    "validation": {
      "passwordRequired": "Nenosiri linahitajika",
      "passwordMinLength": "Nenosiri lazima liwe na angalau vibambo 8",
      "confirmPasswordRequired": "Tafadhali thibitisha nenosiri",
      "passwordsDontMatch": "Manenosiri hayalingani"
    },
    "editUserDescription": "Sasisha maelezo ya mtumiaji",
    "addUserDescription": "Unda mtumiaji mpya katika mfumo",
    "basicInformation": "Taarifa za Msingi",
    "fullNamePlaceholder": "Ingiza jina kamili",
    "passwordSettings": "Mipangilio ya Nywila",
    "passwordPlaceholder": "Ingiza nywila",
    "confirmPasswordPlaceholder": "Thibitisha nywila",
    "passwordHelp": "Nywila lazima iwe na angalau herufi 8",
    "userSettings": "Mipangilio ya Mtumiaji",
    "clientUserDescription": "Mtumiaji wa mteja ana upatikanaji mdogo",
    "inactiveUserDescription": "Watumiaji ambao hawajachangamka hawawezi kuingia kwenye mfumo",
    "noName": "Hakuna jina"
  },
  "user": {
    "system": "Mfumo",
    "account": "Akaunti",
    "explore": "Gundua",
    "profile": "Wasifu",
    "logout": "Kutoka",
    "settings": "Mipangilio",
    "projects": "Miradi",
    "faq": "Msaada",
    "helpAndSupport": "Msaada na usaidizi",
    "administration": "Utawala",
    "help": "Msaada"
  },
  "odkSync": {
    "dashboard": {
      "title": "Dashibodi ya Sinkronizasyon ya ODK"
    },
    "workbench": {
      "contextHint": "Kuangalia usawazishaji wa data kutoka kwa vituvyo vya ODK na kusasisha vikurusi za usawazishaji katika shirika yako kwa kujaribu.",
      "live": "Masasisho ya wakati halisi",
      "reconnect": "Unganisha tena",
      "loading": "Inapakia data ya usawazishaji…",
      "schedulerPill": "Mratibu",
      "schedulerActive": "Imeendelezwa",
      "schedulerPaused": "Imeitishwa",
      "schedulerStopped": "Imeitishwa",
      "statusLive": "Imeendelezwa",
      "statusOffline": "Imeakatwa",
      "statusSchedulerActive": "Imeendelezwa",
      "statusSchedulerPaused": "Imeitishwa",
      "statusSchedulerStopped": "Imeitishwa",
      "createShort": "Mpya",
      "pipeline": {
        "ariaLabel": "Hali ya pipeline ya usawazishaji",
        "scheduler": "Mratibu",
        "schedulerActive": "Inaendelezwa kwa kujaribu",
        "schedulerPaused": "Imeitishwa — wasilisho hawatasawazishwa",
        "pull": "Kutolea mwisho",
        "cursors": "Vikurusi",
        "cursorsHint": "{count} fomu zilizotumika",
        "cursorsEmpty": "Hakuna vikurusi hivi sasa"
      }
    },
    "table": {
      "emptyState": "Hakuna vikurusi za usawazishaji hivi sasa. Ongeza kikurusi cha kwanza kwa kuanza kutolea wasilisho."
    },
    "scheduler": {
      "title": "Mratibu wa Sinkronizasyon",
      "pauseScheduler": "Sitisha Mratibu",
      "resumeScheduler": "Endeleza Mratibu",
      "pausedMessage": "Sinkronizasyon ya data ya ODK iko kusitishwa sasa. Wasilisho mpya hawatasinkronizwa hadi itakapofuatiwa."
    },
    "managerScope": {
      "title": "Kuangalia data ya usawazishaji",
      "message": "Unatumia data ya usawazishaji za {count} miradi zinazotumika. Unatumia data za usawazishaji za miradi zinazotumika kwa miradi zinazotumika."
    },
    "statistics": {
      "title": "Takwimu za Sinkronizasyon",
      "totalCursors": "Jumla ya Vikurusi",
      "lastSync": "Sinkronizasyon ya Mwisho"
    },
    "cursors": {
      "title": "Vikurusi vya Sinkronizasyon",
      "viewModes": {
        "cards": "Kadi",
        "table": "Jedwali",
        "projects": "Kwa Miradi",
        "list": "Orodha"
      },
      "actions": {
        "clear": "Futa",
        "bulkSync": "Sinkronizasyon ya Wingi ({count})",
        "bulkReset": "Weka Upya ya Wingi ({count})",
        "createCursor": "Unda Kikurusi"
      }
    },
    "auto": {
      "managed": "Otomatiki",
      "manual": "Mkono",
      "enableAuto": "Washa Otomatiki ({count})",
      "disableAuto": "Zima Otomatiki ({count})",
      "reason": "Sababu",
      "reasons": {
        "importedActive": "Fomu hai iliyoingizwa",
        "createdActive": "Fomu hai iliyoundwa",
        "uploadedActive": "Fomu hai iliyopakiwa",
        "formOpened": "Fomu imefunguliwa",
        "formClosed": "Fomu imefungwa",
        "formReopened": "Fomu imefunguliwa tena",
        "newFormOpened": "Fomu mpya imefunguliwa",
        "migrated": "Imehamishwa",
        "formNotFound": "Fomu haijapatikana",
        "manualOverride": "Kuzuia kwa mikono",
        "formDeleted": "Fomu imefutwa",
        "importedFormDeleted": "Fomu iliyoingizwa imefutwa"
      }
    },
    "projectSummary": {
      "forms": "Fomu: {count}",
      "lastSync": "Sinkronizasyon ya Mwisho",
      "active": "Zilizotumika: {count}",
      "errors": "Hitilafu: {count}",
      "inactive": "Zisizotumika: {count}",
      "noProjects": "Hakuna Miradi",
      "createFirstCursor": "Unda kikurusi chako cha kwanza cha sinkronizasyon"
    },
    "projectResponsible": {
      "responsible": "Mwenye Jukumu",
      "notAssigned": "Hajagawiwa",
      "assign": "Gawa",
      "remove": "Ondoa",
      "assignModal": {
        "title": "Gawa mwenye jukumu wa mradi \"{project}\"",
        "selectUser": "Chagua mtumiaji",
        "selectUserPlaceholder": "Chagua mtu mwenye jukumu",
        "assign": "Gawa",
        "noUsers": "Hakuna watumiaji waliopo",
        "noUsersMessage": "Hakuna watumiaji katika shirika wa kugawa kama mwenye jukumu wa mradi."
      }
    },
    "modals": {
      "createCursor": {
        "title": "Unda Kikurusi cha Sinkronizasyon",
        "server": "Seva",
        "project": "Mradi",
        "xmlForm": "Fomu ya XML",
        "serverPlaceholder": "Chagua seva",
        "projectPlaceholder": "Chagua mradi",
        "xmlFormPlaceholder": "Chagua fomu"
      },
      "manualSync": {
        "title": "Sinkronizasyon ya Mkono",
        "selectCursors": "Chagua Vikurusi",
        "forceFullSync": "Lazimisha Sinkronizasyon Kamili",
        "maxConcurrent": "Upeo wa Sinkronizasyon Sambamba",
        "startSync": "Anza Sinkronizasyon"
      }
    },
    "messages": {
      "schedulerPaused": "Mratibu wa sinkronizasyon wa ODK umesitishwa",
      "schedulerResumed": "Mratibu wa sinkronizasyon wa ODK umeendelezwa",
      "cursorCreated": "Kikurusi cha sinkronizasyon kimeundwa kwa mafanikio",
      "manualSyncTriggered": "Sinkronizasyon ya mkono imeanzishwa kwa mafanikio",
      "cursorReset": "Kikurusi kimewekwa upya kwa mafanikio",
      "bulkResetSuccess": "Imewekwa upya kwa mafanikio vikurusi {count}",
      "selectCursorsForSync": "Tafadhali chagua angalau kikurusi kimoja kwa sinkronizasyon",
      "never": "Kamwe"
    },
    "errors": {
      "failedToLoadSyncData": "Imeshindwa kupakia data ya sinkronizasyon",
      "failedToControlScheduler": "Imeshindwa kudhibiti mratibu",
      "failedToCreateCursor": "Imeshindwa kuunda kikurusi cha sinkronizasyon",
      "failedToTriggerManualSync": "Imeshindwa kuanzisha sinkronizasyon ya mkono",
      "failedToResetCursor": "Imeshindwa kuweka upya kikurusi",
      "failedToResetSomeCursors": "Imeshindwa kuweka upya vikurusi kadhaa"
    },
    "filters": {
      "showAllForms": "Onyesha fomu zote",
      "filteringTitle": "Kuchuja fomu",
      "filteringMessage": "Inaonyesha {filtered} ya {total} fomu. Zimefichwa {hidden} fomu zilizo na hali ya 'imefungwa', 'haijulikani' au bila hali iliyobainishwa."
    },
    "formStatus": {
      "title": "Hali ya fomu na uboreshaji",
      "checkStatuses": "Angalia hali",
      "statusLabels": {
        "open": "Wazi",
        "closing": "Inafungwa",
        "closed": "Imezunguka",
        "unknown": "Haijulikani"
      },
      "cards": {
        "title": "Hali ya fomu",
        "description": "Angalia na uboresha vikurusi",
        "refresh": "Hudhuri"
      },
      "loading": "Inapakia...",
      "autoCheckInterval": "Dakika 5",
      "lastCheck": "Kiotomatiki kila dakika 5",
      "benefits": {
        "autoDisable": "Kuzima kiotomatiki vikurusi kwa fomu zilizofungwa",
        "resourceOptimization": "Uboreshaji wa rasilimali za sinkronizasyon",
        "performanceImprovement": "Utendaji ulioboreshwa"
      },
      "messages": {
        "checkStarted": "Uangalizi wa hali ya fomu umeanza",
        "checkError": "Hitilafu wakati wa kuangalia hali ya fomu",
        "enableError": "Hitilafu wakati wa kuwasha vikurusi",
        "disableError": "Hitilafu wakati wa kuzima vikurusi"
      }
    }
  },
  "odkQc": {
    "dashboard": {
      "title": "QC Dashboard - Ubora wa Data ODK",
      "description": "Kufuatilia ubora wa data ya ODK submissions kwa kutumia sheria za uthibitishaji"
    },
    "statistics": {
      "totalRules": "Sheria Zote",
      "activeRules": "Sheria Zilizotumika",
      "inactiveRules": "Sheria Zisizotumika",
      "recentValidations": "Uthibitishaji wa Hivi Karibuni"
    },
    "sections": {
      "rulesByType": "Sheria kwa Aina",
      "rulesBySeverity": "Sheria kwa Kiwango cha Uzito",
      "qcRules": "Sheria za QC"
    },
    "filters": {
      "allTypes": "Aina Zote",
      "allLevels": "Ngazi Zote",
      "allStatuses": "Hali Zote",
      "active": "Inatumika",
      "inactive": "Haifanyi Kazi"
    },
    "actions": {
      "createRule": "Unda Sheria",
      "activate": "Washa",
      "deactivate": "Zima",
      "clearSelection": "Ondoa Uteuzi"
    },
    "ruleTypes": {
      "required": "Inahitajika",
      "constraint": "Kizuizi",
      "calculation": "Hesabu",
      "custom": "Maalum"
    },
    "severityLevels": {
      "error": "Hitilafu",
      "warning": "Onyo",
      "info": "Maelezo"
    },
    "messages": {
      "noRuleTypeData": "Hakuna data ya aina ya sheria inayopatikana",
      "noSeverityData": "Hakuna data ya uzito inayopatikana",
      "ruleUpdated": "Sheria imesasishwa kwa mafanikio",
      "ruleCreated": "Sheria imeundwa kwa mafanikio",
      "ruleSaveError": "Hitilafu wakati wa kuhifadhi sheria",
      "ruleLoadError": "Hitilafu wakati wa kupakia data",
      "ruleStatusToggled": "Hali ya sheria {ruleName} imebadilishwa",
      "ruleStatusError": "Hitilafu wakati wa kubadilisha hali ya sheria",
      "confirmDeleteRule": "Futa sheria \"{ruleName}\"?",
      "ruleDeleted": "Sheria imefutwa kwa mafanikio",
      "ruleDeleteError": "Hitilafu wakati wa kufuta sheria",
      "ruleSaved": "Sheria imehifadhiwa kwa mafanikio",
      "bulkStatusToggled": "Hali imebadilishwa kwa sheria {count}",
      "bulkStatusError": "Hitilafu wakati wa kubadilisha hali ya sheria",
      "bulkDeleted": "Imefutwa sheria {count}",
      "bulkDeleteError": "Hitilafu wakati wa kufuta sheria",
      "rulesDeleted": "Sheria zimefutwa",
      "rulesActivated": "Sheria zimewashwa",
      "rulesDeactivated": "Sheria zimezimwa",
      "ruleNotFound": "Sheria haipatikani",
      "invalidJsonFormat": "Umbo la JSON si sahihi",
      "createExpressionFirst": "Tengeneza usemi kwanza",
      "previewError": "Hitilafu wakati wa kutazama",
      "invalidRuleExpression": "Usemi wa sheria si sahihi",
      "ruleNotExecuted": "Sheria haijatekelezwa",
      "loadingRule": "Inapakia sheria...",
      "saving": "Inahifadhi...",
      "loading": "Inapakia...",
      "run": "Endesha",
      "passed": "Imepita",
      "failed": "Imeshindwa",
      "success": "Mafanikio",
      "errorDuringValidation": "Hitilafu wakati wa uhakiki",
      "noQcRulesFound": "Hakuna sheria za QC zilizopatikana"
    },
    "form": {
      "ruleName": "Jina la Sheria",
      "ruleNameRequired": "Jina la sheria linahitajika",
      "fieldPath": "Uga Kuu",
      "fieldPathRequired": "Uga kuu unahitajika",
      "fieldPathHint": "Uga kuu ambao sheria hii inathibitisha.Uga nyingine zinaweza kutumika katika usemi wa JSONLogic.",
      "errorMessage": "Ujumbe wa Hitilafu",
      "errorMessageHint": "Inayotazwa kwa wakulima wakati wa kutokea kwa sheria hii.",
      "errorMessageRequired": "Ujumbe wa hitilafu unahitajika",
      "constraintExpression": "Maneno ya Kizuizi",
      "constraintExpressionHint": "Use '{'\"var\": \"field_name\"'}' para referenciar campos de submissão. Clique em Aplicar para validar JSON.",
      "constraintExpressionRequired": "Maneno ya kizuizi yanahitajika",
      "ruleType": "Aina ya Sheria",
      "severityLevel": "Kiwango cha Uzito",
      "ruleActive": "Sheria inatumika",
      "ruleActiveHint": "Sheria zisizotumika zinaendeshwa lakini hainaendeshwa wakati wa uhakiki.",
      "basicSettings": "Mipangilio ya Msingi",
      "jsonLogicBuilder": "Mjenga JSONLogic",
      "jsonLogicBuilderHint": "Inaendeshwa kwa kujaribu. Usemi unaweza kuendeshwa kwa kweli kwa uwasilisho wa sahihi.",
      "reset": "Weka upya",
      "apply": "Tumia",
      "saveChanges": "Hifadhi Mabadiliko",
      "createRule": "Unda Sheria",
      "editRule": "Hariri Sheria",
      "rulePreview": "Tazama Sheria",
      "testRuleOnSample": "Jaribu sheria kwenye data ya mfano",
      "detailedResults": "Matokeo ya Kina",
      "showSubmissionData": "Onyesha data ya uwasilishaji",
      "help": "Msaada",
      "ruleTypes": "Aina za Sheria",
      "severityLevels": "Ngazi za Uzito",
      "requiredField": "Uga unaohitajika",
      "constraintCheck": "Ukaguzi wa kizuizi",
      "calculatedField": "Uga uliohesabiwa",
      "customLogic": "Mantiki maalum",
      "blocksSubmission": "Inazuia uwasilishaji",
      "showsWarning": "Inaonyesha onyo",
      "informationalMessage": "Ujumbe wa maelezo",
      "jsonLogicExamplesTitle": "Mifano ya maelezo ya JSONLogic kwa hh_question:",
      "agreementCheckExample": "Ukaguzi wa makubaliano:",
      "finalStatusCheckExample": "Ukaguzi wa hali ya mwisho:",
      "enumeratorCheckExample": "Ukaguzi wa mhesabu:",
      "complexLogicExample": "Mantiki ngumu:",
      "fieldValue": "Thamani ya Uga",
      "previewStatsLine": "{passed} imepita · {failed} imeshindwa · {rate}%"
    },
    "placeholders": {
      "searchByNameFieldMessage": "Tafuta kwa jina, uga au ujumbe...",
      "ruleType": "Aina ya sheria",
      "severityLevel": "Kiwango cha uzito",
      "status": "Hali",
      "enterRuleName": "Ingiza jina la sheria",
      "enterErrorMessage": "Ingiza ujumbe wa hitilafu",
      "respondentAge": "respondent.age"
    },
    "table": {
      "ariaLabels": {
        "disableRule": "Zima sheria",
        "enableRule": "Washa sheria"
      }
    },
    "viewModes": {
      "cards": "Kadi",
      "table": "Jedwali"
    }
  },
  "odkCleanup": {
    "page": {
      "title": "Kifuatiliaji cha Usafishaji wa Data ya ODK",
      "subtitle": "Fuatilia mfumo wa usafishaji otomatiki na uone takwimu za data",
      "selectFormTitle": "Chagua Fomu kwa Ajili ya Kufuatilia Usafishaji",
      "currentProject": "Mradi wa Sasa",
      "searchPlaceholder": "Tafuta na uchague fomu...",
      "systemInfo": {
        "title": "Mfumo wa Usafishaji Otomatiki",
        "activeFormsTitle": "Fomu zinazofanya kazi (wazi/kufunga)",
        "activeFormsDesc": "Folda 5 tu za hivi karibuni ndizo huwekwa kiotomatiki. Usafishaji hutokea wakati wa kila uoanishaji.",
        "closedFormsTitle": "Fomu zilizofungwa (zimefungwa)",
        "closedFormsDesc": "Fomu inapofungwa, folda 4 huwekwa kwenye kumbukumbu kiotomatiki, ikibaki 1 kwa ajili ya takwimu.",
        "monitoringTitle": "Ufuatiliaji",
        "monitoringDesc": "Chagua fomu hapo juu ili uone takwimu na ufuatilie mfumo wa usafishaji."
      }
    },
    "manager": {
      "title": "Meneja wa Usafishaji wa Data ya ODK",
      "loading": "Inapakia data ya usafishaji...",
      "noData": {
        "title": "Hakuna Data Inayopatikana",
        "meaning": "Hii inamaanisha nini:",
        "noSubmissions": "Fomu hii haina mawasilisho bado",
        "noSync": "Fomu haijaoanishwa kutoka ODK Central",
        "noCleanupNeeded": "Hakuna usafishaji unaohitajika kwa sasa"
      },
      "errorLoading": "Hitilafu Wakati wa Kupakia Data",
      "stats": {
        "title": "Takwimu za Sasa",
        "totalFolders": "Jumla ya Folda",
        "totalSize": "Jumla ya Ukubwa",
        "completeData": "Data Kamili"
      },
      "formInfo": {
        "title": "Habari za Fomu",
        "state": "Hali:",
        "active": "Inafanya kazi:",
        "lastSubmission": "Wasilisho la Mwisho:",
        "lastSync": "Uoanishaji wa Mwisho:",
        "yes": "Ndiyo",
        "no": "Hapana"
      },
      "recommendation": {
        "title": "Pendekezo la Usafishaji",
        "action": "Hatua:",
        "reason": "Sababu:",
        "requiresApproval": "Inahitaji idhini kwa ajili ya usafishaji"
      },
      "buttons": {
        "refresh": "Sasisha Takwimu",
        "dryRun": "Jaribio la Awali",
        "cleanupNow": "Safisha Sasa",
        "forceCleanup": "Lazimisha Usafishaji"
      },
      "results": {
        "title": "Matokeo ya Usafishaji wa Mwisho",
        "strategy": "Mkakati:",
        "kept": "Imehifadhiwa: folda {count}",
        "deleted": "Imefutwa: folda {count}",
        "archived": "Imehifadhiwa kwenye kumbukumbu: folda {count}",
        "skipped": "Imerukwa: folda {count}"
      },
      "folders": {
        "title": "Folda za Hivi Karibuni ({count})",
        "columns": {
          "name": "Jina la Folda",
          "created": "Imeundwa",
          "size": "Ukubwa (MB)",
          "files": "Faili"
        }
      }
    },
    "messages": {
      "globalCleanupSuccess": "Usafishaji wa jumla umekamilika kwa mafanikio",
      "globalCleanupFailed": "Usafishaji wa jumla umeshindwa",
      "errorLoadingProjects": "Hitilafu wakati wa kupakia miradi",
      "errorLoadingForms": "Hitilafu wakati wa kupakia fomu",
      "noDataOrSync": "Fomu hii haina data au haijaoanishwa bado",
      "statsLoadFailed": "Imeshindwa kupakia takwimu za usafishaji",
      "dryRunSuccess": "Jaribio la awali limekamilika - hakuna faili zilizofutwa",
      "dryRunFailed": "Jaribio la awali limeshindwa",
      "cleanupNotRecommended": "Usafishaji haupendekezwi kwa fomu hii",
      "cleanupSuccess": "Usafishaji umekamilika kwa mafanikio",
      "cleanupFailed": "Usafishaji umeshindwa",
      "forceNotAvailable": "Lazimisha usafishaji haupatikani kwa fomu hii",
      "forceConfirm": "Je, una uhakika unataka kulazimisha usafishaji? Hatua hii haiwezi kutenguliwa.",
      "forceSuccess": "Lazimisha usafishaji umekamilika kwa mafanikio",
      "forceFailed": "Lazimisha usafishaji umeshindwa"
    }
  },
  "permissionGroups": {
    "create": "Tengeneza Kikundi",
    "delete": "Futa Kikundi",
    "assignToUser": "Weka Kikundi kwa Mtumiaji",
    "removeFromUser": "Ondoa Kikundi kutoka kwa Mtumiaji",
    "roleNames": {
      "manager": "Meneja",
      "projectMember": "Mwanachama wa mradi",
      "dataViewer": "Mtazamaji wa Data",
      "dataCollector": "Mkusanyaji wa Data",
      "dataDownloader": "Mpakua wa Data",
      "dataAnalyst": "Mchambuzi wa Data",
      "qcViewer": "Mtazamaji wa QC",
      "qcEditor": "Mbuni wa QC",
      "monitor": "Mkusanyaji wa QC",
      "formDesigner": "Mbuni wa Fomu"
    },
    "userManagement": {
      "clientGroups": "Vikundi vya Kliki",
      "clientGroupsDescription": "Vikundi vinavyolengwa kwa watumiaji wa nje au wa mteja.",
      "regularGroups": "Vikundi vya Kawaida",
      "regularGroupsDescription": "Vikundi vinavyolengwa kwa washiriki wa ndani wa mradi.",
      "errorTitle": "Haikuwezekana kupakia vikundi",
      "noProjectsTitle": "Chagua mradi kwanza",
      "noProjectsDescription": "Chagua mradi kabla ya kugawa vikundi vya ruhusa.",
      "noGroupsTitle": "Hakuna vikundi vinavyopatikana",
      "noGroupsAvailable": "Hakuna vikundi vinavyopatikana kwa kuweka",
      "errorLoadingGroups": "Hitilafu katika kupakia vikundi",
      "selectedGroups": "Vikundi vilivyochaguliwa",
      "selectedCount": "{count} vimechaguliwa",
      "selectedPill": "Kimechaguliwa",
      "includedPermissions": "Ruhusa zilizojumuishwa",
      "groupDetailsTitle": "Maelezo ya kikundi",
      "groupDescriptionFallback": "Hakuna maelezo yaliyotolewa.",
      "rolesCount": "Majukumu: {count}",
      "viewGroupDetails": "Tazama majukumu katika {name}"
    }
  },
  "menu": {
    "dashboard": "Dashibodi",
    "my-organization": "Shirika langu",
    "userManagement": "Usimamizi wa Mtumiaji",
    "organizationStats": "Takwimu za Shirika",
    "organizationSettings": "Mipangilio ya Shirika",
    "projects": "Miradi",
    "odkServers": "Seva za ODK",
    "odkSync": "Sinkronizasyon ya ODK",
    "payments": "Malipo",
    "faq": "Msaada",
    "preferences": "Mapendeleo ya akaunti",
    "settings": "Mipangilio ya programu",
    "billing": "Bili",
    "help": "Msaada"
  },
  "organization": {
    "settingsSubtitle": "Simamia wasifu wa shirika, usajili wa AI, ramani, na miundombinu iliyounganishwa.",
    "profile": {
      "sectionTitle": "Wasifu wa shirika",
      "name": "Jina",
      "description": "Maelezo",
      "edit": "Hariri",
      "editTitle": "Hariri shirika",
      "noDescription": "Hakuna maelezo",
      "created": "Imeundwa",
      "updated": "Imesasishwa",
      "loadError": "Imeshindwa kupakia wasifu wa shirika"
    },
    "infrastructure": {
      "sectionTitle": "Miundombinu iliyounganishwa",
      "subtitle": "Muhtasari wa seva, miradi, watumiaji na fomu zinazotumika.",
      "servers": "Seva za ODK",
      "projects": "Miradi",
      "users": "Watumiaji",
      "activeForms": "Fomu zinazotumika",
      "defaultServer": "Seva ya ODK chaguo-msingi",
      "noDefaultServer": "Hakuna seva chaguo-msingi",
      "manageServers": "Simamia seva za ODK",
      "viewSync": "Fungua Sync Workbench",
      "loadError": "Imeshindwa kupakia muhtasari wa miundombinu"
    },
    "quickLinks": {
      "sectionTitle": "Kurasa husika",
      "userManagement": "Usimamizi wa watumiaji",
      "statistics": "Takwimu za shirika",
      "projects": "Miradi",
      "odkServers": "Seva za ODK",
      "syncWorkbench": "Usawazishaji",
      "reportTemplates": "Violezo vya ripoti"
    }
  },
  "preferences": {
    "title": "Mapendeleo",
    "subtitle": "Hariri wasifu wa akaunti, ufikiaji wa shirika, vikundi vya ruhusa na majukumu ya mradi.",
    "accessOverview": "Muhtasari wa ufikiaji",
    "organizationOwner": "Mmiliki wa shirika",
    "organizationOwnerDescription": "Una ufikiaji kamili kwa rasilimali na miradi yote ya shirika.",
    "permissionGroups": "Vikundi vya ruhusa",
    "permissionGroupsDescription": "Vikundi kwa kila mradi na majukumu yao",
    "perProject": "Kwa mradi",
    "noProjectGroups": "Hakuna vikundi maalum vya mradi.",
    "projectsAccess": "Ufikiaji wa miradi",
    "projectsAccessDescription": "Miradi unayoweza kufungua na majukumu yako",
    "ownerNoProjects": "Kama mmiliki wa shirika, una ufikiaji kamili. Miradi itaonekana baada ya kuundwa au kuingizwa.",
    "noProjectAccess": "Hakuna ufikiaji wa mradi uliotolewa bado.",
    "projectIdLabel": "Kitambulisho: {id}",
    "projectLabelFallback": "Mradi #{id}",
    "memberSince": "Mwanachama tangu:",
    "userFallback": "Mtumiaji",
    "invalidDate": "Tarehe batili",
    "name": "Jina",
    "email": "Barua pepe",
    "password": "Nenosiri",
    "resetPassword": "Weka upya nenosiri",
    "emailSubscriptions": "Usajili wa barua pepe",
    "emailSubscriptionsVisit": "Kudhibiti barua pepe unazopokea, tembelea",
    "notificationSettingsLink": "Mipangilio ya arifa",
    "cancelAccount": "Futa akaunti",
    "cancelAccountDescription": "Futa kabisa shirika lako, watumiaji na data yote inayohusiana.",
    "cancelAccountAction": "Futa akaunti",
    "editName": "Hariri jina",
    "editNameSubtitle": "Sasisha jina linaloonekana katika programu.",
    "nameRequired": "Jina linahitajika",
    "nameMinLength": "Jina lazima liwe na angalau herufi 2",
    "nameUpdateFailed": "Imeshindwa kusasisha jina. Tafadhali jaribu tena.",
    "nameChangedSuccess": "Umebadilisha jina lako kwa mafanikio",
    "resetPasswordTitle": "Weka upya nenosiri",
    "resetPasswordSubtitle": "Weka nenosiri la sasa kisha chagua jipya.",
    "passwordRequirementsTitle": "Mahitaji ya nenosiri",
    "currentPassword": "Nenosiri la sasa",
    "newPassword": "Nenosiri jipya",
    "repeatNewPassword": "Rudia nenosiri jipya",
    "passwordMinLength": "Lazima liwe na angalau herufi 8",
    "passwordUniqueChars": "Lazima liwe na angalau herufi 6 tofauti",
    "updatePassword": "Sasisha nenosiri",
    "passwordChangedSuccess": "Umebadilisha nenosiri lako kwa mafanikio",
    "passwordUpdateFailed": "Imeshindwa kusasisha nenosiri. Tafadhali jaribu tena.",
    "currentPasswordRequired": "Sehemu ya nenosiri la sasa inahitajika",
    "newPasswordRequired": "Sehemu ya nenosiri jipya inahitajika",
    "repeatPasswordRequired": "Sehemu ya kurudia nenosiri inahitajika",
    "passwordMatchUnique": "Nenosiri jipya haiwezi kuwa sawa na la sasa",
    "confirmPasswordMismatch": "Uthibitishaji haulingani na nenosiri jipya",
    "dangerZoneTitle": "Eneo hatari",
    "dangerZoneSubtitle": "Vitendo visivyoweza kutenduliwa vinavyoathiri shirika lako lote.",
    "cancelAccountModalTitle": "Futa akaunti",
    "cancelAccountModalSubtitle": "Thibitisha utambulisho wako na kwamba unataka kufuta akaunti kabisa.",
    "cancelAccountConsequenceOrg": "Shirika lako na miradi yote itafutwa",
    "cancelAccountConsequenceUsers": "Wanachama wote wa shirika watapoteza ufikiaji",
    "cancelAccountConsequenceOdk": "Data ya ODK inayohusishwa inaweza kuondolewa kabisa",
    "cancelAccountConsequenceIrreversible": "Kitendo hiki hakiwezi kutenduliwa",
    "cancelAccountConfirmEmailLabel": "Andika barua pepe yako kuthibitisha",
    "cancelAccountConfirmEmailRequired": "Uthibitishaji wa barua pepe unahitajika",
    "cancelAccountConfirmEmailMismatch": "Barua pepe hailingani na akaunti yako",
    "cancelAccountAcknowledge": "Naelewa kuwa hii itafuta kabisa shirika langu na data yote inayohusiana",
    "cancelAccountAcknowledgeRequired": "Lazima uthibitishe kuwa unaelewa matokeo",
    "cancelAccountDeleteButton": "Futa akaunti kabisa",
    "cancelAccountUnavailableTitle": "Kufuta akaunti bado hakupatikani",
    "cancelAccountUnavailableMessage": "Utambulisho wako umethibitishwa. Kufuta akaunti kunaandaliwa — wasiliana na msimamizi au msaada kuomba kufungwa kwa akaunti.",
    "cancelAccountWrongPassword": "Nenosiri si sahihi. Tafadhali jaribu tena.",
    "dangerZoneCancelAccount": "Eneo hatari: Futa akaunti",
    "cancelAccountWarning": "Hii itafuta kabisa akaunti yako na data yote inayohusiana, ikiwa ni pamoja na shirika, watumiaji na data ya ODK.",
    "groupFallback": "Kikundi"
  },
  "faq": {
    "title": "Msaada",
    "subtitle": "Miongozo mifupi na majibu kwa kazi za kawaida za UDACAPI."
  },
  "settings": {
    "title": "Mipangilio",
    "subtitle": "Sasisha maambukizi ya programu, lugha na mapendeleo ya arifa.",
    "themeSection": "Tema",
    "generalSection": "Mapendeleo ya kawaida",
    "notificationsNoticeTitle": "Mipangilio yako ya arifa imepangwa upya na kurahisishwa",
    "notificationsNoticeBody": "Chaguo zako za awali za mipangilio hazijabadilishwa."
  },
  "projects": {
    "pageTitle": "Miradi",
    "subtitle": "Sasisha miradi, chagua kadi au jedwali, na kuanza mfumo wa kuingiza au kuunda.",
    "refresh": "Sasisha",
    "createProject": "Unda Mradi",
    "importRestrictions": {
      "message": "Mafanikio ya kuangalia ni inayofanyika kwa ajili ya kubadili kwa mfano katika mfomu. Kwa mfano, unaweza kuangalia kwa ajili ya kubadili kwa mfano katika mfomu."
    },
    "viewMode": {
      "cards": "Kadi",
      "table": "Jedwali"
    },
    "sections": {
      "forms": {
        "title": "Mfomu za mradi"
      },
      "users": {
        "title": "Watumiaji wa mradi"
      },
      "formAccess": {
        "title": "Ufikiaji wa fomu",
        "description": "Chagua App Users gani wanaweza kupakua kila fomu katika ODK Collect.",
        "save": "Hifadhi",
        "discard": "Ghairi",
        "saving": "Inahifadhi…",
        "saved": "Ufikiaji wa fomu umehifadhiwa",
        "saveError": "Imeshindwa kuhifadhi mabadiliko yote",
        "loadError": "Imeshindwa kupakia ufikiaji wa fomu",
        "emptyForms": "Hakuna fomu zilizochapishwa katika mradi huu",
        "emptyAppUsers": "Bado hakuna App Users. Tengeneza msimbo wa QR kwanza.",
        "openQr": "Fungua QR workbench",
        "openForms": "Fungua fomu",
        "dirtyHint": "Mabadiliko yasiyohifadhiwa"
      },
      "info": {
        "title": "Maelezo ya mradi",
        "basicInfo": "Maelezo ya msingi",
        "accessInfo": "Ufikiaji",
        "statistics": "Takwimu za mradi",
        "fields": {
          "projectId": "Kitambulisho cha mradi",
          "name": "Jina",
          "description": "Maelezo",
          "status": "Hali",
          "orgId": "Kitambulisho cha shirika",
          "odkProjectId": "Kitambulisho cha mradi wa ODK",
          "createdAt": "Tarehe ya kuundwa",
          "updatedAt": "Ilisasishwa mwisho",
          "yourRole": "Jukumu lako",
          "canManageForms": "Anaweza kusimamia fomu",
          "canViewUsers": "Anaweza kuona watumiaji",
          "isManager": "Ni msimamizi",
          "isOwner": "Ni mmiliki",
          "totalUsers": "Watumiaji wa mradi"
        },
        "status": {
          "active": "Hai",
          "archived": "Imehifadhiwa"
        },
        "noDescription": "Hakuna maelezo",
        "loading": "Inapakia maelezo ya mradi...",
        "loadError": "Imeshindwa kupakia maelezo ya mradi",
        "statsLoadError": "Imeshindwa kupakia takwimu za mradi",
        "invalidDate": "Tarehe si sahihi",
        "notAvailable": "Hapana"
      }
    },
    "users": {
      "dialog": {
        "addTitle": "Ongeza mtumiaji kwenye mradi",
        "editTitle": "Hariri ufikiaji wa mradi",
        "addSubtitle": "Chagua mtumiaji kwanza, kisha mpe vikundi vya ruhusa kwa mradi huu.",
        "editSubtitle": "Kagua mtumiaji aliyechaguliwa na usasishe vikundi vya ruhusa kwa mradi huu.",
        "stepOne": "Hatua ya 1",
        "stepTwo": "Hatua ya 2",
        "stepReady": "Tayari",
        "stepRequired": "Lazima",
        "stepLocked": "Imefungwa",
        "selectUserTitle": "Chagua mtumiaji",
        "selectedUser": "Mtumiaji aliyechaguliwa",
        "selectUserHint": "Chagua nani anapaswa kupewa ufikiaji wa mradi huu.",
        "selectedUserHint": "Mtumiaji huyu tayari amewekwa kwenye mradi. Unaweza kusasisha vikundi vyake vya ruhusa hapa chini.",
        "selectUserPlaceholder": "Chagua mtumiaji",
        "selectUserHelper": "Wamiliki na superusers hawaonyeshwi kwenye orodha hii.",
        "permissionGroupsTitle": "Vikundi vya ruhusa",
        "permissionGroupsHint": "Chagua kikundi kimoja au zaidi cha ruhusa kwa mtumiaji aliyechaguliwa.",
        "permissionGroupsLockedTitle": "Chagua mtumiaji ili uendelee",
        "permissionGroupsLockedHint": "Vikundi vya ruhusa vitaonekana baada ya kuchagua mtumiaji.",
        "addToProject": "Ongeza kwenye mradi",
        "clientUser": "Mtumiaji wa mteja",
        "internalUser": "Mtumiaji wa ndani"
      },
      "dialogs": {
        "removeUser": {
          "title": "Ondoa mtumiaji kutoka kwenye mradi",
          "message": "Una uhakika unataka kumuondoa mtumiaji huyu kutoka kwenye mradi?",
          "confirm": "Ondoa"
        }
      },
      "list": {
        "searchPlaceholder": "Tafuta watumiaji",
        "filterByPermissionGroups": "Chuja kwa vikundi vya ruhusa",
        "accessDeniedTitle": "Ufikiaji umekataliwa",
        "accessDeniedMessage": "Huna ruhusa ya kuona watumiaji wa mradi huu.",
        "loadErrorTitle": "Haikuwezekana kupakia watumiaji wa mradi",
        "emptyTitle": "Bado hakuna watumiaji kwenye mradi",
        "emptyMessage": "Ongeza mtumiaji wa kwanza ili uanze kusimamia ufikiaji wa mradi.",
        "emptyFilteredTitle": "Hakuna mtumiaji anayelingana na vichujio vya sasa",
        "emptyFilteredMessage": "Jaribu kubadilisha maandishi ya utafutaji au vikundi vya ruhusa vilivyochaguliwa.",
        "noPermissionGroups": "Hakuna vikundi vya ruhusa"
      },
      "messages": {
        "saveSuccess": "Ufikiaji wa mtumiaji umesasishwa kwa mafanikio.",
        "removeSuccess": "Mtumiaji ameondolewa kutoka kwenye mradi."
      },
      "errors": {
        "assignGroupsFailed": "Imeshindwa kugawa vikundi vya ruhusa. Tafadhali jaribu tena.",
        "assignRoleFailed": "Imeshindwa kugawa jukumu la mradi.",
        "loadUsersFailed": "Imeshindwa kupakia watumiaji wa mradi.",
        "permissionGroupsLoadFailed": "Imeshindwa kupakia vikundi vya ruhusa.",
        "projectMemberRoleFailed": "Imeshindwa kutambua jukumu la project member.",
        "removeUserFailed": "Imeshindwa kumuondoa mtumiaji kwenye mradi.",
        "rolesLoadFailed": "Imeshindwa kupakia majukumu ya mradi.",
        "saveUserFailed": "Imeshindwa kusasisha ufikiaji wa mradi."
      }
    },
    "modal": {
      "addProject": "Ongeza mradi",
      "editProject": "Hariri mradi",
      "unsavedChanges": "Fomu ina mabadiliko ambayo hayajahifadhiwa. Una uhakika unataka kuifunga?"
    },
    "form": {
      "projectName": {
        "label": "Jina la Mradi",
        "placeholder": "Ingiza jina la mradi",
        "required": "Jina la mradi linahitajika"
      },
      "odkServer": {
        "label": "Seva ya ODK",
        "placeholder": "Chagua seva ya ODK",
        "required": "Seva ya ODK inahitajika",
        "noServers": "Hakuna seva za ODK zinazopatikana. Tafadhali ongeza seva kwanza."
      },
      "description": {
        "label": "Maelezo",
        "placeholder": "Maelezo ya hiari ya mradi"
      },
      "buttons": {
        "cancel": "Ghairi"
      }
    },
    "cards": {
      "noProjects": "Hakuna miradi",
      "status": {
        "active": "Amilifu",
        "archived": "Imehifadhiwa"
      }
    },
    "confirmations": {
      "odkServerRequired": "Tafadhali ongeza angalau seva moja ya ODK kabla ya kuunda mradi.",
      "delete": {
        "imported": {
          "title": "Futa mradi ulioingizwa",
          "message": "Una uhakika unataka kufuta mradi \"{name}\"?\n\nMradi huu uliingizwa kutoka ODK Central. Utafutwa tu kutoka hifadhidata ya programu hii, lakini utabaki kwenye seva ya ODK Central.",
          "messageWithStats": "Una uhakika unataka kufuta mradi \"{name}\"?\n\nMradi huu ina {formsCount} fomu na {submissionsCount} wasilisho.\nMradi itahifadhiwa/itazungumza (soft-delete), na data itazaiwa.\n\nMradi huu uliingizwa kutoka ODK Central. Utafutwa tu kutoka hifadhidata ya programu hii, lakini utabaki kwenye seva ya ODK Central."
        },
        "regular": {
          "title": "Futa mradi",
          "message": "Una uhakika unataka kufuta mradi \"{name}\"?\n\nONYO: Hii itafuta kabisa mradi kutoka hifadhidata ya programu hii na seva ya ODK Central.",
          "messageWithStats": "Una uhakika unataka kufuta mradi \"{name}\"?\n\nMradi huu ina {formsCount} fomu na {submissionsCount} wasilisho.\nMradi itahifadhiwa/itazungumza (soft-delete), na data itazaiwa."
        },
        "confirmButton": "Futa"
      }
    },
    "notifications": {
      "organizationNotSelected": "Shirika halijachaguliwa"
    },
    "import": {
      "title": "Ingiza Miradi ya ODK",
      "subtitle": "Ongeza miradi ya ODK zilizopatikana kutoka kwa seva ya shirika na ingiza kwenye eneo hili.",
      "selectServer": "Chagua Seva ya ODK",
      "getProjects": "Pata Miradi",
      "availableProjects": "Miradi Inayopatikana",
      "noProjectsFound": "Hakuna miradi iliyopatikana kwenye seva iliyochaguliwa.",
      "importProject": "Ingiza",
      "imported": "Imeingizwa",
      "errors": {
        "serversLoadFailed": "Haikuweza kupakia seva za ODK. Tafadhali jaribu tena baadaye.",
        "projectsLoadFailed": "Haikuweza kupakia miradi kutoka kwa seva ya ODK. Tafadhali angalia muunganisho na ujaribu tena.",
        "importFailed": "Haikuweza kuingiza mradi. Tafadhali jaribu tena baadaye.",
        "importError": "Hitilafu wakati wa kuingiza mradi: {detail}"
      }
    },
    "importForms": {
      "title": "Ingiza Fomu za ODK",
      "subtitle": "Chagua fomu kutoka kwa mradi wako wa ODK Central ili kuziweka hapa.",
      "subtitleWithProject": "Chagua fomu kutoka kwa mradi wa Central {odkProjectId} ili kuziweka kwenye {name}.",
      "loadingForms": "Inapakia fomu kutoka kwa seva ya ODK...",
      "availableForms": "Fomu Zinazopatikana",
      "searchForms": "Tafuta fomu...",
      "selectAll": "Chagua Zote",
      "deselectAll": "Acha Kuchagua Zote",
      "importSelected": "Ingiza Zilizochaguliwa",
      "noFormsFound": "Hakuna fomu zilizopatikana kwa mradi huu kwenye seva ya ODK.",
      "errors": {
        "projectNotLinked": "Mradi haujounganishwa na seva ya ODK",
        "formsLoadFailed": "Haikuweza kupakia fomu kutoka kwa seva ya ODK. Tafadhali jaribu tena baadaye.",
        "formsLoadError": "Hitilafu wakati wa kupakia fomu: {detail}",
        "importFailed": "Haikuweza kuingiza fomu. Tafadhali jaribu tena baadaye.",
        "importError": "Hitilafu ya kuingiza: {detail}"
      },
      "status": {
        "imported": "Imeingizwa",
        "available": "Inapatikana"
      },
      "progress": {
        "started": "Uingizaji umeanza",
        "completedSummary": "Fomu ziko tayari katika mradi huu.",
        "failedSummary": "Baadhi ya fomu hazikuweza kuingizwa. Angalia maelezo hapa chini.",
        "viewProject": "Angalia mradi",
        "forms": "{done} / {total} fomu",
        "submissions": "{count} wasilisho walioachwa",
        "submissionsProgress": "{fetched} / {total} wasilisho zimesawazishwa",
        "stages": {
          "queued": "Inasubiri kuanza",
          "pending": "Inasubiri kuanza",
          "importingForms": "Inaingiza fomu",
          "syncingData": "Inasawazisha data"
        },
        "messages": {
          "queued": "Kazi imewekwa kwenye foleni na inasubiri kuanza...",
          "importingForms": "Inaingiza metadata ya fomu..."
        }
      }
    },
    "detail": {
      "loading": "Inapakia mradi...",
      "returnToProjects": "Rudi kwenye miradi",
      "forms": {
        "title": "Fomu za mradi",
        "noForms": "Mradi hauna fomu.",
        "contactAdmin": "Wasiliana na msimamizi ili kuongeza fomu.",
        "actions": {
          "publish": "Chapisha",
          "abandon": "Acha",
          "attachments": "Vifungo",
          "qrCode": "Msimbo QR wa kujaribu",
          "previewEnketo": "Onyesho la awali katika Enketo",
          "downloadTestData": "Pakua data ya majaribio",
          "formSettings": "Mipangilio ya fomu",
          "viewDetails": "Ona/Maelezo",
          "changeState": "Badilisha hali",
          "delete": "Futa/Acha"
        },
        "modals": {
          "qrCode": {
            "title": "Msimbo QR wa kujaribu",
            "description": "Skani msimbo QR ili kujaribu fomu"
          },
          "formSettings": {
            "title": "Mipangilio ya fomu",
            "basicSettings": "Mipangilio ya msingi (Placeholder)",
            "accessSettings": "Mipangilio ya ufikiaji (Placeholder)",
            "placeholder": "Hii ni kiolesura cha maonyesho. Utendaji uko katika maendeleo."
          }
        },
        "messages": {
          "tryAgain": "Jaribu tena",
          "publishing": "Inachapisha fomu {name}...",
          "published": "Fomu {name} imechapishwa kwa mafanikio",
          "previewing": "Onyesho la awali la {name} katika Enketo (dev placeholder)",
          "downloading": "Inapakua data ya majaribio ya {name} (dev placeholder)",
          "saving": "Inahifadhi mipangilio ya {name} (dev placeholder)",
          "missingData": "Data haipo ya kuingiza fomu",
          "missingXlsformData": "Data haipo ya kupakia XLSForm",
          "noAttachments": "Fomu haina viambatisho"
        }
      }
    },
    "qc": {
      "rules": {
        "ruleTypes": {
          "required": "Required field",
          "constraint": "Constraint",
          "calculation": "Calculation",
          "custom": "Custom"
        },
        "severity": {
          "error": "Error",
          "warning": "Warning",
          "info": "Info"
        },
        "form": {
          "tabs": {
            "basic": "Basic settings",
            "preview": "Preview"
          },
          "ruleNameLabel": "Rule name *",
          "ruleNamePlaceholder": "Enter rule name",
          "ruleTypeLabel": "Rule type *",
          "severityLabel": "Severity level *",
          "fieldPathLabel": "Field path *",
          "fieldPathPlaceholder": "respondent.age",
          "constraintExpressionLabel": "Constraint expression *",
          "calculationFormulaLabel": "Calculation formula *",
          "simpleEditor": "Simple editor",
          "jsonLogicBuilder": "JSONLogic Builder",
          "applyJsonLogic": "Apply JSONLogic",
          "errorMessageLabel": "Error message *",
          "errorMessagePlaceholder": "Enter error message",
          "activeLabel": "Rule active",
          "previewTitle": "Rule Preview",
          "runPreview": "Run Preview",
          "previewHint": "Tests rule on sample data",
          "invalidJson": "Invalid JSON format",
          "createExpressionFirst": "Create rule expression first",
          "previewError": "Error executing preview",
          "previewResults": "Preview results ({count} records):",
          "passed": "Passed:",
          "failed": "Failed:",
          "successRate": "Success rate:",
          "validation": {
            "ruleNameRequired": "Rule name is required",
            "fieldPathRequired": "Field path is required",
            "errorMessageRequired": "Error message is required",
            "constraintExpressionRequired": "Constraint expression is required",
            "calculationFormulaRequired": "Calculation formula is required"
          },
          "toasts": {
            "ruleCreated": "Rule created successfully",
            "ruleUpdated": "Rule updated successfully",
            "saveError": "Error saving rule"
          }
        }
      }
    }
  },
  "odkServers": {
    "title": "Seva za ODK",
    "subtitle": "Sasisha seva za ODK za shirika, mipangilio, kujulikana na muunganisho wa kikao.",
    "addServer": "Ongeza seva",
    "editServer": "Hariri seva",
    "deleteServer": "Futa seva",
    "modal": {
      "addSubtitle": "Unganisha seva ya ODK Central na shirika hili.",
      "editSubtitle": "Sasisha mipangilio ya muunganisho wa seva."
    },
    "table": {
      "default": "Chaguo-msingi",
      "visibility": "Kujulikana",
      "setAsDefault": "Weka kama chaguo-msingi",
      "setAsDefaultTooltip": "Weka kama seva ya chaguo-msingi ya shirika hili",
      "testConnection": "Jaribu muunganisho",
      "testConnectionTooltip": "Jaribu muunganisho wa seva ya ODK Central",
      "testConnectionDisabled": "Kujaribu muunganisho kunapatikana tu kwa seva za shirika",
      "editServer": "Hariri seva",
      "editServerTooltip": "Hariri maelezo ya seva (tu kwa seva za SHIRIKA na ikiwa una ruhusa)",
      "deleteServer": "Futa seva",
      "deleteServerTooltip": "Futa seva (tu kwa seva za SHIRIKA na ikiwa una ruhusa)",
      "odkSession": "Kikao cha ODK"
    },
    "session": {
      "banner": "Seva moja au zaidi zina kikao cha ODK Central kinachokwisha au si halali, au hakuna nenosiri lililohifadhiwa. Hariri seva na uhifadhi nenosiri ili programu iweze kuunganisha tena kiotomatiki.",
      "ok": "Kikao sawa",
      "expiresSoon": "Kitaisha hivi karibuni",
      "expired": "Imeisha",
      "unknown": "Haijulikani",
      "noStoredPassword": "Hakuna nenosiri lililohifadhiwa"
    },
    "form": {
      "serverName": "Jina la seva",
      "serverUrl": "URL ya seva",
      "serverUrlPlaceholder": "https://your-odk-central.com",
      "username": "Jina la mtumiaji",
      "password": "Nenosiri",
      "passwordPlaceholderEdit": "Acha tupu ili usibadilishe",
      "description": "Maelezo",
      "serverIsActive": "Seva inafanya kazi",
      "serverIsActiveHint": "Seva zisizotumika zinaendelea kuonekana lakini hazitolewi unapounda miradi."
    },
    "validation": {
      "serverNameRequired": "Jina la seva ni lazima",
      "serverUrlRequired": "URL ya seva ni lazima",
      "urlFormatInvalid": "URL lazima ianze na http:// au https://",
      "usernameRequired": "Jina la mtumiaji ni lazima",
      "passwordRequired": "Nenosiri ni lazima"
    },
    "messages": {
      "selectOrganizationFirst": "Tafadhali chagua au unda shirika kwanza",
      "loadingServers": "Inapakia seva...",
      "noServersFound": "Hakuna seva za ODK zilizopatikana kwa shirika hili",
      "failedToLoadServers": "Imeshindwa kupakia seva",
      "noServers": "Hakuna seva za ODK",
      "serverSaved": "Seva \"{name}\" {action} kwa mafanikio!",
      "serverSetAsDefault": "Seva \"{name}\" imewekwa kama chaguo-msingi",
      "connectionTestSuccess": "Muunganisho umefanikiwa. Miradi iliyopatikana: {count}",
      "connectionTestFailed": "Kujaribu muunganisho hakukufaulu"
    },
    "contextHint": "Unganisha seva yako ya ODK kabla ya kusawazisha au kuagiza fomu."
  },
  "notifications": {
    "all": "Ona arifa zote",
    "less": "Ona arifa chache"
  },
  "language": {
    "label": "Lugha",
    "english": "Kiingereza",
    "spanish": "Kihispania",
    "french": "Kifaransa",
    "swahili": "Kiswahili",
    "portuguese": "Kireno",
    "ukrainian": "Kiukraine",
    "russian": "Kirusi",
    "turkish": "Kituruki"
  },
  "auth": {
    "createAccount": "Unda akaunti",
    "dontHaveAccount": "Huna akaunti?",
    "email": "Barua pepe",
    "emailInvalid": "Barua pepe inapaswa kuwa halali",
    "emailRequired": "Sehemu ya barua pepe inahitajika",
    "enterEmail": "Weka barua pepe yako",
    "enterVerificationCode": "Tafadhali weka msimbo wa uthibitisho",
    "forgotPassword": "Umesahau nywila?",
    "forgotPasswordDescription": "Ikiwa umesahau nywila yako, usiwe na wasiwasi. Tu weka anwani ya barua pepe yako hapa chini, na tutakutumia barua pepe na maagizo ya kuweka upya nywila yako. Kurejesha upatikanaji wa akaunti yako hakujawahi kuwa rahisi kama hivi.",
    "fullName": "Jina kamili",
    "fullNameRequired": "Sehemu ya jina kamili inahitajika",
    "goBack": "Rudi nyuma",
    "haveAccount": "Una akaunti?",
    "login": "Ingia",
    "password": "Nywila",
    "passwordMustContainLetter": "Nywila inapaswa kuwa na herufi angalau moja",
    "passwordMustContainNumber": "Nywila inapaswa kuwa na nambari angalau moja",
    "passwordMustContainSpecial": "Nywila inapaswa kuwa na alama maalum angalau moja",
    "passwordMustBe8Chars": "Nywila inapaswa kuwa na herufi 8 au zaidi",
    "passwordRequired": "Sehemu ya nywila inahitajika",
    "passwordRequirements": "Nywila inapaswa kuwa na herufi 8+: herufi, nambari na alama maalum.",
    "passwordsDontMatch": "Nywila hazifanani",
    "registrationFailed": "Usajili ulishindwa. Tafadhali jaribu tena.",
    "registrationSuccess": "Umesajili kwa mafanikio! Tafadhali angalia barua pepe yako kwa maagizo ya uanzishaji.",
    "repeatPassword": "Rudia nywila",
    "repeatPasswordRequired": "Sehemu ya kurudia nywila inahitajika",
    "resetInstructionsSent": "Maagizo ya kuweka upya nywila yametumwa kwenye barua pepe yako.",
    "resetInstructionsFailed": "Imeshindwa kutuma barua pepe ya kuweka upya nywila. Tafadhali jaribu tena.",
    "resetPassword": "Weka upya nywila",
    "sendResetInstructions": "Tuma maagizo ya kuweka upya",
    "signUp": "Jisajili",
    "twoFactorAuthentication": "Uthibitisho wa mambo mawili",
    "verificationCode": "Msimbo wa uthibitisho",
    "verificationCodeRequired": "Msimbo wa uthibitisho unahitajika",
    "verifyCode": "Thibitisha msimbo"
  },
  "dashboard": {
    "subtitle": "Nyumbani na kuonekana zaidi za stats na maelezo muhimu.",
    "activeFormsTitle": "Fomu Zilizotumika",
    "activeFormsSubtitle": "Nambari na hali ya fomu zilizotumika.",
    "noActiveForms": "Hakuna fomu zilizotumika"
  },
  "qr": {
    "title": "Msimbo QR (Mipangilio ya ODK Collect)",
    "titleShort": "Msimbo QR",
    "qrName": "Jina la msimbo QR",
    "projectSection": "Mradi",
    "projectName": "Jina la mradi",
    "projectIcon": "Imepeleka ya mradi",
    "projectColor": "Rangi ya mradi",
    "generalSection": "Mipangilio ya msingi",
    "serverUrl": "URL ya seva",
    "username": "Jina la mtumiaji",
    "password": "Nenosiri",
    "adminSection": "Mipangilio ya admin",
    "admin": {
      "edit_saved": "Hariri kuweka",
      "send_finalized": "Wasilisha kuweka",
      "view_sent": "Onyesha kuweka",
      "password": "Nenosiri la msimamizi",
      "advanced": "Usimamizi wa kina",
      "getBlank": "Pata tupu",
      "deleteSaved": "Futa zilizohifadhiwa",
      "qrCodeScanner": "Kichanganuzi cha msimbo QR",
      "changeServer": "Badilisha seva",
      "changeAppTheme": "Badilisha mandhari ya programu",
      "changeAppLanguage": "Badilisha lugha ya programu",
      "changeFontSize": "Badilisha ukubwa wa fonti",
      "changeNavigation": "Badilisha usogezaji",
      "maps": "Ramani",
      "periodicUpdates": "Masasisho ya mara kwa mara",
      "automaticUpdate": "Sasisho la kiotomatiki",
      "hideOldVersions": "Ficha matoleo ya zamani",
      "changeAutosend": "Badilisha utumaji otomatiki",
      "deleteAfterSend": "Futa baada ya kutuma",
      "defaultToFinalized": "Chaguomsingi kuwa imekamilika",
      "changeConstraintBehavior": "Badilisha tabia ya vikwazo",
      "highResolution": "Ubora wa juu",
      "imageSize": "Ukubwa wa picha",
      "guidanceHint": "Kidokezo cha mwongozo",
      "externalAppRecording": "Kurekodi kwa programu ya nje",
      "instanceFormSync": "Usawazishaji wa fomu za matukio",
      "changeFormMetadata": "Badilisha metadata ya fomu",
      "analytics": "Uchanganuzi",
      "movingBackwards": "Kurudi nyuma",
      "accessSettings": "Fikia mipangilio",
      "changeLanguage": "Badilisha lugha",
      "jumpTo": "Ruka hadi",
      "saveMid": "Hifadhi katikati",
      "saveAs": "Hifadhi kama",
      "markAsFinalized": "Weka alama kuwa imekamilika"
    },
    "actions": {
      "generate": "Genga msimbo QR",
      "downloadPng": "Pakua PNG",
      "copyBase64": "Kopya Base64",
      "reset": "Weka upya",
      "importJson": "Ingiza JSON"
    },
    "placeholder": "Genga msimbo QR ili tuone kwenye hapa",
    "note": "Msimbo una Base64 iliyobanwa kwa zlib ya JSON yenye general/admin/project. Uthibitishaji wa App User uko katika server_url.",
    "general": {
      "theme": "Mandhari",
      "language": "Lugha",
      "fontSize": "Ukubwa wa fonti",
      "navigation": "Usogezaji",
      "constraintBehavior": "Tabia ya vikwazo",
      "advanced": "Mipangilio ya jumla ya kina",
      "formlistUrl": "URL ya orodha ya fomu",
      "submissionUrl": "URL ya mawasilisho",
      "periodicUpdates": "Masasisho ya mara kwa mara",
      "deleteAfterSend": "Futa baada ya kutuma",
      "defaultCompleted": "Chaguomsingi imekamilika",
      "externalAppRecording": "Kurekodi kwa programu ya nje"
    },
    "formManagement": {
      "title": "Usimamizi wa fomu",
      "updateMode": "Hali ya usasishaji",
      "autosend": "Utumaji otomatiki",
      "imageSize": "Ukubwa wa picha",
      "automaticUpdate": "Sasisho la kiotomatiki",
      "hideOldVersions": "Ficha matoleo ya zamani",
      "instanceSync": "Usawazishaji wa matukio",
      "guidanceHint": "Kidokezo cha mwongozo",
      "highResolution": "Ubora wa juu"
    },
    "maps": {
      "title": "Ramani",
      "basemap": "Ramani ya msingi",
      "googleStyle": "Mtindo wa Google",
      "mapboxStyle": "Mtindo wa Mapbox",
      "usgsStyle": "Mtindo wa USGS",
      "cartoStyle": "Mtindo wa CARTO",
      "referenceLayer": "Tabaka la marejeleo (njia)"
    },
    "identity": {
      "title": "Utambulisho",
      "analytics": "Uchanganuzi",
      "userName": "Jina la mtumiaji",
      "email": "Email",
      "phone": "Simu"
    },
    "presets": {
      "title": "Miundo ya QR",
      "save": "Hifadhi muundo",
      "load": "Pakia muundo...",
      "delete": "Futa",
      "defaultName": "Muundo {number}"
    },
    "preview": {
      "title": "Hakikisho la JSON",
      "reset": "Weka upya",
      "import": "Ingiza"
    },
    "history": {
      "title": "Misimbo QR iliyotengenezwa",
      "viewAll": "Tazama zote",
      "view": "Tazama",
      "download": "Pakua",
      "copy": "Nakili",
      "delete": "Futa",
      "more": "... na {count} zaidi"
    },
    "placeholders": {
      "qrName": "QR ya kifaa changu",
      "color": "#C17A3A",
      "url": "https://central.example.org",
      "submissionUrl": "https://.../v1/projects/:id/submissions",
      "referenceLayer": "/storage/maps/layer.mbtiles",
      "icon": "📋",
      "projectName": "Timu ya uwanja"
    },
    "options": {
      "default": "Chaguomsingi",
      "system": "Mfumo"
    },
    "messages": {
      "nameRequiredForPreset": "Tafadhali ingiza jina la muundo",
      "nameRequiredForAppUser": "Jina la msimbo QR linahitajika kuunda App User",
      "invalidSettings": "Mipangilio si sahihi",
      "generateError": "Imeshindwa kutengeneza QR na kuunda App User",
      "invalidJsonStructure": "Muundo wa JSON si sahihi. Lazima uwe na sehemu za project, general, na admin.",
      "invalidJsonFormat": "Umbizo la JSON si sahihi",
      "copyBase64Error": "Imeshindwa kunakili Base64",
      "projectNameRequired": "Jina la mradi linahitajika",
      "serverRequired": "URL ya seva inahitajika",
      "missingOdkProject": "Mradi huu hauna id ya mradi wa ODK Central. Ingiza tena au angalia mipangilio.",
      "generateSuccess": "QR imetengenezwa na App User imeundwa",
      "presetSaved": "Muundo umehifadhiwa",
      "base64Copied": "Base64 imenakiliwa",
      "jsonImported": "Mipangilio imewekwa kutoka JSON"
    },
    "workbench": {
      "contextHint": "Unda QR ya ODK Collect na tokeni ya App User ndani ya URL ya seva.",
      "serverReady": "Seva imewekwa",
      "essentialsTitle": "Sanidi",
      "essentialsDesc": "Taja QR na kadi ya Collect, chagua ikoni na rangi, kisha tengeneza.",
      "nameHint": "Inatumika pia kama jina la App User katika ODK Central.",
      "serverHint": "Inachukuliwa kutoka seva ya ODK iliyounganishwa. Uzalishaji huingiza /v1/key/{token}/projects/{id}.",
      "advancedTitle": "Chaguo za juu za Collect",
      "advancedHint": "Mandhari, sync, ramani — hiari",
      "previewTitle": "Hakikisho",
      "previewDesc": "Changanua kwa ODK Collect baada ya kutengeneza.",
      "libraryHint": "Imehifadhiwa katika kivinjari hiki kwa mradi huu.",
      "libraryEmpty": "Bado hakuna misimbo QR. Tengeneza moja kuanza.",
      "libraryCount": "{count} katika maktaba",
      "serverMeta": "Central: {url}",
      "serverMissing": "Central: haijaunganishwa — angalia seva ya ODK ya mradi",
      "projectNameHint": "Lebo katika ODK Collect ya usanidi huu (si jina la mradi wa udacapi).",
      "iconHint": "Inaonekana kwenye kadi ya mradi katika Collect. Chaguomsingi kinatosha kwa wengi.",
      "changeIcon": "Badilisha ikoni",
      "iconDialogTitle": "Ikoni ya mradi wa Collect",
      "iconDialogSubtitle": "Chagua glyph moja kwa kadi ya mradi kwenye kifaa.",
      "applyIcon": "Tumia ikoni"
    },
    "formAccess": {
      "title": "Fomu ambazo mkusanyaji huyu anaweza kufikia",
      "hint": "Chagua angalau fomu moja iliyochapishwa. Bila hiyo, Collect inaonyesha orodha tupu.",
      "selectAll": "Chagua zote",
      "clear": "Futa uteuzi",
      "required": "Chagua angalau fomu moja",
      "assignFailed": "Imeshindwa kuwapa App User fomu",
      "manageAll": "Simamia ufikiaji wote wa fomu",
      "formsCount": "fomu {n}",
      "noPublishedForms": "Bado hakuna fomu zilizochapishwa katika mradi huu."
    }
  },
  "forms": {
    "state": {
      "open": "Wazi",
      "closing": "Inafungwa",
      "closed": "Imefungwa",
      "draft": "Rasimu"
    },
    "deleteConfirm": {
      "title": "Futa fomu",
      "subtitle": "Kagua matokeo kabla ya kufuta fomu hii kabisa.",
      "message": "Hatua hii haiwezi kutenguliwa.",
      "xmlFormId": "XML ID: {id}",
      "confirm": "Futa kabisa",
      "importedWarning": "Fomu hii uliingizwa kutoka ODK Central. Itafutwa tu kutoka hifadhidata ya programu hii na utabaki kwenye seva ya ODK Central.",
      "regularWarning": "Hatua hii inahamisha fomu kwenye takataka ya ODK Central na kuashiria kama ilifutwa ndani.",
      "consequenceDataLoss": "Majibu yote na historia ya uhamishaji wa fomu hii yataondolewa kwenye programu hii.",
      "irreversible": "Hatua hii haiwezi kutenguliwa kupitia kiolesura hiki.",
      "success": "Fomu {name} imefutwa.",
      "successImported": "Fomu {name} imefutwa tu kutoka hifadhidata ya programu hii.",
      "error": "Hitilafu wakati wa kufuta fomu: {error}"
    },
    "uploadXlsform": {
      "title": "Pakia XLSForm",
      "subtitle": "Chagua kitabu cha kazi (.xlsx au .xls, hadi 50 MB) kuunda au kusasisha fomu.",
      "selectFile": "Chagua faili la XLSForm",
      "dropFileTitle": "Dondosha kitabu chako cha XLSForm hapa",
      "supportedFormats": "Miundo inayokubalika: .xlsx na .xls, hadi 50 MB.",
      "replaceFileHint": "Chagua faili lingine kubadilisha uteuzi wa sasa.",
      "chooseFile": "Vinjari faili",
      "selectedFile": "Faili ulilochagua:",
      "formSettings": "Kitambulisho cha fomu",
      "uploadOptions": "Chaguo za kupakia",
      "formId": "ID ya fomu",
      "formIdPlaceholder": "my_form_id",
      "formIdHint": "ID ya kipekee ya fomu (herufi, nambari na underscores pekee)",
      "formIdWarning": {
        "title": "Muhimu!",
        "message": "ID ya fomu itatolewa kwa kutumia faili la XLSForm ('settings' sheet). Hii ni kiolesura cha maonyesho."
      },
      "updateExisting": "Sasisha fomu iliyopo",
      "updateExistingHint": "Ikiwa fomu yenye ID hii ipo tayari, itasasishwa",
      "ignoreWarnings": "Puuza onyo",
      "ignoreWarningsHint": "Puuza onyo wakati wa kubadilisha",
      "publishImmediately": "Chapisha fomu mara moja",
      "publishImmediatelyHint": "Chapisha fomu mara moja",
      "uploadButton": "Pakia XLSForm",
      "uploading": "Inapakia...",
      "noFileSelected": "Tafadhali chagua faili la kupakia",
      "noFormId": "Tafadhali weka ID ya fomu",
      "uploadingMessage": "Inapakia XLSForm \"{formId}\"...",
      "successMessage": "XLSForm \"{formId}\" imepakia kikamilifu!",
      "errorMessage": "Hitilafu wakati wa kupakia: {error}",
      "errorFallback": "Upakiaji umeshindwa. Tafadhali jaribu tena.",
      "listUpdated": "XLSForm imepakia kikamilifu! Orodha imesasishwa."
    },
    "formDetail": {
      "loading": "Inapakia fomu...",
      "formLabel": "Fomu",
      "returnToProjects": "Rudi kwenye orodha ya miradi",
      "sectionShell": {
        "unknownForm": "Fomu isiyojulikana",
        "loading": "Inapakia...",
        "retry": "Jaribu tena",
        "comingSoonTitle": "Bado",
        "comingSoonDescription": "Hatua hii inaendeshwa. Tafadhali jaribu kutumia vifaa vya fomu vingine vya kuongeza."
      },
      "sections": {
        "dashboard": {
          "title": "Muhtasari wa Fomu",
          "description": "Takwimu na maelezo kuhusu fomu na data iliyokusanywa"
        },
        "qc": {
          "title": "Udhibiti wa Ubora",
          "description": "Fuatilia na thibitisha ubora wa data kwa kutumia sheria za QC",
          "workbench": {
            "contextHint": "Bainisha sheria, thibitisha mawasilisho, na kagua masuala yaliyowekwa alama kwa fomu hii.",
            "rulesCount": "Sheria {count}",
            "activeCount": "{count} amilifu",
            "validationsCount": "Uthibitishaji {count}",
            "summaryTitle": "Muhtasari wa sheria",
            "selectedCount": "{count} zimechaguliwa",
            "createRuleHint": "Tengeneza kura la kuangazia kwa fomu hii",
            "editRuleHint": "Sasisha sheria na ifadhi",
            "backToRules": "Rudi kwenye sheria",
            "pipeline": {
              "ariaLabel": "Mtiririko wa uthibitishaji wa QC",
              "define": "Bainisha sheria",
              "defineHint": "Sheria {count} zimesanidiwa",
              "defineEmpty": "Bado hakuna sheria — unda ukaguzi wako wa kwanza",
              "validate": "Thibitisha data",
              "validateHint": "Mawasilisho {count} yamekaguliwa",
              "validateEmpty": "Endesha uthibitishaji kwenye mawasilisho yanayoingia",
              "review": "Kagua masuala",
              "reviewHint": "Masuala {count} wazi",
              "reviewClear": "Hakuna masuala yasiyotatuliwa"
            }
          }
        },
        "dataExport": {
          "title": "Usafirishaji wa Data",
          "description": "Hamisha data ya fomu katika fomati mbalimbali"
        },
        "odkExport": {
          "title": "Usafirishaji wa data",
          "description": "Hamisha data ya fomu katika fomati mbalimbali kwa uchambuzi",
          "unknownForm": "Fomu isiyojulikana",
          "exportsCount": "usafirishaji {count}",
          "loadingOptions": "Inapakia chaguzi za usafirishaji...",
          "retry": "Jaribu tena",
          "infoSubtitleDetailed": "Chagua fomati za usafirishaji na usanidi chaguzi ili kupakua data yako ya fomu.",
          "formatsAvailable": "fomati {count} zinapatikana",
          "formatsTitle": "Fomati za Usafirishaji",
          "selectFormats": "Chagua fomati moja au zaidi za kusafirisha",
          "statisticalFormatsTitle": "Fomati za Takwimu",
          "geoFormatsTitle": "Fomati za Kijiografia",
          "noGeoData": "Hakuna data ya kijiografia iliyopatikana katika fomu hii",
          "configTitle": "Usanidi wa Usafirishaji",
          "configSubtitle": "Sanidi chaguzi za usafirishaji na vichungi",
          "dataOptions": "Chaguzi za Data",
          "includeRepeats": "Jumuisha vikundi vinavyojirudia",
          "includeLabels": "Jumuisha lebo za nyanja",
          "includeMetadata": "Jumuisha metadata",
          "labelLanguage": "Lugha ya Lebo",
          "selectLanguage": "Chagua Lugha",
          "loadingLanguages": "Inapakia lugha...",
          "generatingLabels": "Inatengeneza lebo...",
          "noLabelsAvailable": "Hakuna lebo zinazopatikana. Bofya pakia upya ili kutengeneza lebo.",
          "filters": "Vichungi",
          "dateRange": "Kiwango cha Tarehe",
          "startDate": "Tarehe ya Kuanza",
          "endDate": "Tarehe ya Kumaliza",
          "dataFilter": "Kichungi cha Data",
          "dataFilterPlaceholder": "kwa mfano, umri > 18",
          "readyToExport": "Tayari kwa Usafirishaji",
          "readyToExportSubtitle": "Bofya kitufe ili kuanza mchakato wa kusafirisha",
          "labelsRequiredNotice": "Lebo zinahitajika lakini hazipatikani. Tafadhali tengeneza lebo kwanza.",
          "activeExports": "Usafirishaji Amilifu",
          "exportButton": "Hamisha Data",
          "historyTitle": "Historia ya Usafirishaji",
          "historySubtitle": "Angalia na pakua usafirishaji uliopita",
          "refresh": "Pakia upya",
          "loadingHistory": "Inapakia historia...",
          "noHistory": "Hakuna usafirishaji bado",
          "noHistoryDesc": "Anza kwa kusafirisha data katika fomati unayopendelea.",
          "workbench": {
            "contextHint": "Chagua fomati na vichungi, kisha chagua usafirishaji.",
            "geoAvailable": "Data ya kijiografia",
            "geoUnavailable": "Hakuna data ya kijiografia",
            "optionsTitle": "Vichungi",
            "refreshLabels": "Pakia upya lebo",
            "labelsGenerated": "Lebo zimeoundwa ({count} lugha)",
            "exportButtonOne": "Usafirisha 1 fomati",
            "exportButtonMany": "Usafirisha {count} fomati",
            "selectFormatHint": "Chagua angalau fomati moja kwa kusafirisha.",
            "readySummaryOne": "1 fomati zinazofanyika kwa kusafirisha.",
            "readySummaryMany": "{count} fomati zinazofanyika kwa kusafirisha.",
            "jobsTitle": "Kazi",
            "jobsSubtitle": "Jika mafanikio ya usafirishaji zimejipatikana na pakua faili za usafirishaji uliopita.",
            "noActiveJobs": "Hakuna usafirishaji zimejipatikana.",
            "noHistoryAction": "Chagua fomati moja ili kusafirisha.",
            "pipeline": {
              "sync": "Sasisha data",
              "convert": "Changanya",
              "ready": "Tayari"
            }
          },
          "date": "Tarehe",
          "format": "Fomati",
          "records": "Kumbukumbu",
          "size": "Ukubwa",
          "user": "Mtumiaji",
          "actions": "Vitendo",
          "download": "Pakua",
          "viewError": "Angalia Hitilafu",
          "errorDetails": "Maelezo ya Hitilafu",
          "errorSubtitle": "Habari ya hitilafu ya utekelezaji wa usafirishaji",
          "close": "Funga",
          "deleteTitle": "Futa Usafirishaji",
          "deleteSubtitle": "Hatua hii haiwezi kutenguliwa",
          "deleteConfirm": "Je, una uhakika unataka kufuta usafirishaji wa {date}? Hatua hii haiwezi kutenguliwa.",
          "cancel": "Ghairi",
          "delete": "Futa",
          "formatDescriptions": {
            "stata": "Stata",
            "spss": "SPSS",
            "excel": "Excel",
            "csv": "CSV",
            "geojson": "GeoJSON",
            "shapefile": "ESRI Shapefile",
            "kml": "KML",
            "odata": "OData"
          },
          "dateFilters": {
            "all": "Data zote",
            "last30": "Siku 30 zilizopita",
            "last90": "Siku 90 zilizopita",
            "thisyear": "Mwaka huu",
            "lastyear": "Mwaka jana",
            "custom": "Kiwango maalum"
          },
          "status": {
            "odataSyncError": "Hitilafu ya ukaguzi wa usawazishaji wa OData: {error}",
            "localDataMissing": "Data za ndani zinakosekana, inapakua OData...",
            "odataStatusError": "Hitilafu ya hali ya OData",
            "downloadingOdata": "Inapakua OData...",
            "downloadSuccessCount": "Imepakua mawasilisho {count}",
            "downloadError": "Hitilafu ya kupakua OData: {error}",
            "geoRequired": "{format} inahitaji data ya kijiografia"
          },
          "notifications": {
            "selectFormat": "Tafadhali chagua angalau fomati moja",
            "startingDownload": "Inaanza kupakua...",
            "downloadSuccess": "Faili imepakuliwa kwa mafanikio",
            "downloadError": "Hitilafu ya kupakua: {error}",
            "taskIdMissing": "Haiwezi kupakua: ID ya kazi inakosekana",
            "exportDeleted": "Usafirishaji umefutwa kwa mafanikio",
            "exportCompleted": "Usafirishaji {format} umekamilika",
            "exportFailed": "Usafirishaji {format} umeshindwa",
            "trackingError": "Hitilafu ya kufuatilia: {error}",
            "noErrorDetails": "Hakuna maelezo ya hitilafu yanayopatikana",
            "currentUser": "Mtumiaji wa Sasa"
          }
        },
        "dataAnalysis": {
          "title": "Uchambuzi wa Data",
          "description": "Chagua tabla pivot kwa kuchangia kwa kujifunza na kusambaza kuangazia kwa kusambaza kwenye kutazama",
          "recordsLoaded": "{count} kumbukumbu zimeoundwa",
          "variablesSelected": "{count} vigezo vinavyoselecta",
          "tablesAvailable": "{count} tabla zinazopatikana",
          "workbench": {
            "contextHint": "Chagua vigezo, kujifunza na tabla pivot, kisha chagua kuunda kuangazia kwa kusambaza kwenye kutazama",
            "loadingData": "Inapakia data...",
            "pipeline": {
              "ariaLabel": "Uchambuzi wa workflow",
              "source": "Maneno ya data",
              "sourceHint": "{table}",
              "sourceEmpty": "Chagua tabla ya data",
              "variables": "Vigezo",
              "variablesHint": "{count} vigezo vinavyoselecta",
              "variablesEmpty": "Chagua bidhaa kwa kuchangia",
              "pivot": "Tabla pivot",
              "pivotHint": "{count} kumbukumbu zimeoundwa",
              "pivotEmpty": "Inapakia data kwa kujifunza",
              "pivotLoading": "Inapakia kumbukumbu...",
              "save": "Sambaza kuangazia",
              "saveHint": "Tayari kwa kusambaza kwenye kutazama",
              "saveEmpty": "Chagua tabla pivot kwanza"
            },
            "source": {
              "title": "Maneno ya data",
              "subtitle": "Chagua tabla ya kusanyaji na jinsi inavyoonyeshwa",
              "labelsMissing": "Lebo haziwezi kutengeneza kwa fomu hii",
              "labelsMissingHint": "Tengeneza lebo kwa kutumia XLSForm kuonyesha jina la vigezo na lebo la thamani.",
              "generateLabels": "Tengeneza lebo kwa kutumia XLSForm kuonyesha jina la vigezo na lebo la thamani",
              "table": "Tabla ya data",
              "tablePlaceholder": "Chagua tabla ya data",
              "displayOptions": "Vichungi vya kuonyesha",
              "showLabels": "Onyesha lebo",
              "language": "Lugha",
              "includeMetadata": "Jumuisha metadata"
            },
            "variables": {
              "title": "Vigezo",
              "selectedCount": "{count} vigezo vinavyoselecta",
              "selectTableFirst": "Chagua tabla ya data kuangalia vigezo vinavyopatikana.",
              "selectAll": "Chagua kila kitu",
              "clearAll": "Futa kila kitu",
              "searchPlaceholder": "Tafuta vigezo...",
              "empty": "Hakuna vigezo yoyafanyika kuwa sawa na utafutaji wako",
              "moreCount": "+{count} zaidi",
              "loading": "Inapakia...",
              "loadCta": "Inapakia {count} vigezo"
            },
            "pivot": {
              "title": "Tabla pivot",
              "subtitle": "Tuma bidhaa kwa mstari, mstari, au thamani kuunda kuangazia kwa kusambaza kwenye kutazama",
              "hint": "Tuma vigezo kwa mstari, mstari, au thamani. Kama leo la kuangazia kwa kusambaza kwenye kutazama inaonekana sahihi, sambaza ito kama tabla ya kutazama.",
              "reprocess": "Sasisha kuchangia kwa kujifunza",
              "saveCta": "Sambaza kwenye kutazama",
              "analyticsProcessed": "{percent}% inayofanyika kwa kujifunza"
            },
            "empty": {
              "title": "Chagua vigezo",
              "hint": "Chagua kwa moja kwa kwanza au zaidi vigezo kwa kuanza kuchangia kwa kujifunza."
            },
            "save": {
              "title": "Sambaza tabla ya kutazama",
              "subtitle": "Weka jina la tabla hii ili kujifunza na kusambaza kwenye kutazama",
              "tableName": "Jina la tabla",
              "tableNamePlaceholder": "Weka jina la tabla",
              "description": "Maelezo",
              "descriptionPlaceholder": "Nini inaonyesha tabla hii?",
              "summary": "Jumla ya kuchangia kwa kujifunza",
              "variables": "Vigezo",
              "table": "Tabla",
              "cancel": "Ghairi",
              "confirm": "Sambaza tabla"
            },
            "toasts": {
              "labelsGenerated": "Lebo zimeoundwa. Inapakia vigezo...",
              "labelsFailed": "Haiwezi kutengeneza lebo. Tafadhali angalia kuwa XLSForm inaweza kufanyika.",
              "saveSuccess": "Tabla imeoundwa. Funga Data Monitoring kuangalia ito.",
              "saveFailed": "Haiwezi kusambaza tabla. Jaribu tena au fanya msaada wa kusaidia.",
              "formIdMissing": "ID ya fomu haipatikana",
              "reprocessSuccess": "Kuchangia kwa kujifunza inayofanyika kwa mafanikio: {count} kumbukumbu mpya",
              "reprocessFailed": "Kuchangia kwa kujifunza inayofanyika kwa mafanikio umeshindwa",
              "reprocessError": "Hitilafu ya kuchangia kwa kujifunza inayofanyika kwa mafanikio: {error}"
            }
          }
        },
        "dataMonitoring": {
          "title": "Kutazama Data",
          "description": "Angalia tabla ya kutazama zimeoundwa na updates kwa mfano wa kuwasiliana",
          "tablesCount": "{count} tabla",
          "updating": "Inapakia upya...",
          "workbench": {
            "contextHint": "Chagua kuunda kuangazia kwa kusambaza kwenye kutazama na kuwasiliana na data kwa mfano wa kuwasiliana",
            "activeViewsCount": "{count} kuunda kuangazia kwa kusambaza kwenye kutazama",
            "liveStrip": {
              "ariaLabel": "Hali ya kutazama",
              "saved": "Tabla zimeoundwa",
              "savedHint": "{count} tabla zinazofanyika kwa mafanikio",
              "savedEmpty": "Hakuna tabla zimeoundwa hivi sasa",
              "watch": "Kuunda kuangazia kwa kusambaza kwenye kutazama",
              "watchHint": "Angalia {title}",
              "watchEmpty": "Chagua tabla kuangalia",
              "watchDisabled": "Chagua tabla kwanza",
              "sync": "Kusambaza kwenye kuwasiliana",
              "syncHint": "Inapakia upya kwa mfano wa kuwasiliana",
              "syncActive": "Inapakia upya sasa..."
            },
            "displayOptions": {
              "title": "Vichungi vya kuonyesha",
              "subtitle": "Kontrolia jinsi inavyoonyeshwa jina la vigezo katika tabla pivot",
              "showLabels": "Onyesha lebo",
              "language": "Lugha"
            },
            "summary": {
              "title": "Kwa mfano wa kuwasiliana",
              "tables": "Tabla zimeoundwa",
              "activeView": "Kuunda kuangazia kwa kusambaza kwenye kutazama",
              "records": "Kumbukumbu katika kutazama",
              "refreshInterval": "Inapakia upya kwa mfano wa kuwasiliana"
            },
            "tables": {
              "title": "Tabla ya kutazama",
              "subtitle": "Chagua kuunda kuangazia kwa kusambaza kwenye kutazama na sambaza ito hapa.",
              "loading": "Inapakia tabla ya kutazama...",
              "emptyTitle": "Hakuna tabla ya kutazama hivi sasa",
              "emptyHint": "Chagua kuunda kuangazia kwa kusambaza kwenye kutazama na sambaza ito hapa.",
              "createCta": "Nenda kwa kuchangia kwa kujifunza",
              "realtimeHint": "Data inapakia upya kwa mfano wa kuwasiliana kwa 30 siku baada ya kuwasiliana. Tumia Refresh kwa kuwasiliana kwa mfano wa kuwasiliana.",
              "records": "{count} kumbukumbu",
              "lastUpdated": "Inapakia upya kwa mfano wa kuwasiliana {time}",
              "view": "Angalia",
              "hide": "Ficha",
              "loadingPivot": "Inapakia data pivot...",
              "public": "Umma",
              "private": "Privat"
            },
            "delete": {
              "title": "Futa tabla",
              "confirm": "Futa tabla \"{title}\"?",
              "detail": "Hatua hii inafuta tabla hii na data zimeoundwa kwa kutazama kwa muda mrefu.",
              "cancel": "Ghairi",
              "confirmBtn": "Futa tabla"
            }
          }
        },
        "settings": {
          "title": "Mipangilio",
          "description": "Usimamizi wa mipangilio ya bidhaa",
          "formStatus": "Hali ya Bidhaa",
          "basicSettings": "Mipangilio ya Msingi",
          "notifications": {
            "noChanges": "Hakuna mabadiliko ya kuhifadhi",
            "draftWarning": "Rasimu za bidhaa haziwezi kubadilishwa kupitia kiolesura hiki. Kwanza chapa bidhaa.",
            "stateChangeHint": "Kubadilisha hali ya bidhaa huathiri kama utumaji mpya unakubaliwa.",
            "invalidState": "Hali ya bidhaa isiyo halali: {state}",
            "success": "Hali ya fomu imebadilishwa kwa mafanikio hadi {state}",
            "error": "Hitilafu ya kubadilisha hali ya bidhaa: {error}",
            "errorLog": "Hitilafu ya kubadilisha hali ya bidhaa"
          },
          "version": {
            "title": "Toleo",
            "notSpecified": "Haijatajwa",
            "history": "Historia ya Toleo",
            "noHistory": "Hakuna historia ya toleo inayopatikana",
            "download": "Pakua",
            "restore": "Rudisha",
            "uploadNew": "Pakia Toleo Jipya",
            "author": "Mwandishi"
          },
          "dataCollectors": {
            "title": "Wakusanyaji wa Data",
            "description": "Simamia ufikiaji wa watumiaji wa ukusanyaji wa data ya fomu",
            "noCollectors": "Hakuna wakusanyaji wa data walioagizwa",
            "addCollector": "Ongeza Mkusanyaji",
            "editCollector": "Hariri Mkusanyaji",
            "removeCollector": "Ondoa Mkusanyaji",
            "addCollectorModal": {
              "title": "Ongeza Mkusanyaji wa Data",
              "placeholder": "Stub: hapa kutakuwa na fomu ya kuongeza mkusanyaji wa data"
            }
          },
          "publicAccess": {
            "title": "Ufikiaji wa Umma",
            "description": "Unda kiungo cha umma kwa ukusanyaji wa data kupitia kiolesura cha wavuti",
            "publicLink": "Kiungo cha Umma",
            "disable": "Lemaza",
            "requireAuth": "Omba uthibitishaji",
            "collectEmail": "Kusanya barua pepe",
            "limitSubmissions": "Punguza idadi ya majibu",
            "maxSubmissions": "Idadi ya juu ya majibu",
            "updateSettings": "Sasisha Mipangilio",
            "createLink": "Unda Kiungo cha Umma",
            "notCreated": "Kiungo cha umma hakijafanywa. Fanya kiungo kwa ukusanyaji wa data kupitia kiolesura cha wavuti.",
            "created": "Kiungo cha umma kimeundwa",
            "copied": "Kiungo kimeakiliwa kwenye kibao cha kunakili",
            "disabled": "Kiungo cha umma kimelemazwa",
            "updated": "Mipangilio ya kiungo cha umma imesasishwa"
          },
          "qrCodes": {
            "title": "Misimbo ya QR kwa ajili ya kukusanya data",
            "description": "Simamia misimbo ya QR kwa ajili ya kusanidi vifaa vya kukusanya data kwa ajili ya fomu hii",
            "assignedTitle": "Misimbo ya QR iliyoagizwa",
            "availableTitle": "Misimbo ya QR ya mradi inayopatikana",
            "createNew": "Tengeneza msimbo mpya wa QR",
            "noAvailable": "Hakuna misimbo ya QR inayopatikana",
            "createInstruction": "Tengeneza msimbo wa QR kwa ajili ya kusanidi vifaa vya kukusanya data",
            "manageOnProject": "Misimbo ya QR ya ODK Collect inasimamiwa katika kiwango cha mradi (App Users).",
            "openProjectQr": "Fungua misimbo ya QR ya mradi",
            "openFormAccess": "Simamia ufikiaji wa fomu",
            "notifications": {
              "assigned": "Msimbo ya QR umeagizwa kwenye fomu",
              "unassigned": "Msimbo ya QR umeondolewa kwenye fomu",
              "copied": "Base64 itakiliwa kwenye ubao wa kunakili",
              "copyError": "Hitilafu ya kunakili: {error}"
            }
          },
          "attachments": {
            "title": "Viambatanishi na Faili za Media",
            "description": "Simamia faili na viambatanishi vinavyohusiana na fomu",
            "xlsformFile": "Faili ya XLSForm",
            "xlsformDescription": "Pakua faili ya asili ya XLSForm ya fomu hii katika umbizo la Excel",
            "downloadXlsform": "Pakua XLSForm",
            "manageAttachments": "Simamia Viambatanishi",
            "downloadSuccess": "Faili ya XLSForm imepakuliwa kwa mafanikio",
            "downloadError": "Hitilafu ya kupakua faili ya XLSForm",
            "fileNotFound": "Faili ya XLSForm haijapatikana kwa fomu hii",
            "accessDenied": "Hakuna ufikiaji wa kupakua faili ya XLSForm",
            "serverError": "Hitilafu ya seva: {status}"
          },
          "analytics": {
            "title": "Usimamizi wa uchambuzi",
            "recreateAnalytics": "Lazimisha uundaji upya wa uchambuzi",
            "description": "Unda upya data ya uchambuzi kwa maombi yote ya fomu. Tumia hii wakati data ya uchambuzi imeharibika au haipo.",
            "warning": "Kitendo hiki kitaondoa uchambuzi wote uliopo na kuuunda upya kutoka data ghafi ya maombi.",
            "confirmTitle": "Thibitisha uundaji upya wa uchambuzi",
            "alertTitle": "Onyo: Uundaji upya wa data unahitajika",
            "alertDescription": "Kitendo hiki kitaondoa kabisa data yote ya uchambuzi iliyopo na kuuunda upya kutoka mwanzo.",
            "whatWillHappen": "Nini kitatokea:",
            "step1": "Data yote ya uchambuzi iliyopo itaondolewa",
            "step2": "Data ghafi ya maombi itachakatwa tena",
            "step3": "Data mpya ya uchambuzi itaundwa na muundo sahihi",
            "step4": "Majedwali ya pivot na vipengele vya uchambuzi vitafanya kazi vizuri",
            "timeWarning": "Kitendo hiki kinaweza kuchukua dakika kadhaa kwa fomu zenye maombi mengi.",
            "recreateButton": "Lazimisha uundaji upya wa uchambuzi",
            "confirmButton": "Ndiyo, unda upya uchambuzi",
            "success": "Uchambuzi umeundwa upya kwa mafanikio! Maombi {processed} yamechakatwa, rekodi {recreated} za uchambuzi zimeundwa upya kati ya {total} maombi jumla.",
            "error": "Imeshindwa kuunda upya data ya uchambuzi",
            "apiError": "Hitilafu ya API: {error}"
          },
          "dangerZone": {
            "title": "Eneo la Hatari",
            "deleteForm": "Futa Fomu",
            "description": "Hatua hii haiwezi kubatilishwa. Data zote zilizokusanywa zitapotea.",
            "confirmDelete": "Thibitisha Ufutaji wa Fomu",
            "confirmMessage": "Je, una uhakika unataka kufuta fomu \"{name}\"?",
            "confirmDescription": "Hatua hii haiwezi kubatilishwa. Data zote zilizokusanywa zitapotea.",
            "enterFormName": "Ingiza jina la fomu ili kuthibitisha",
            "deleteFormButton": "Futa Fomu",
            "formDeleted": "Fomu imefutwa (kazi ya stub)"
          }
        },
        "datasets": {
          "title": "Seti za Data",
          "description": "Usimamizi wa seti za data na vitu"
        }
      },
      "errors": {
        "missingParams": "Vigezo muhimu vimekosekana kwa kupakia fomu",
        "loadError": "Hitilafu ya kupakia data ya fomu",
        "unknownError": "Hitilafu isiyojulikana"
      }
    },
    "dashboard": {
      "loading": "Inapakia uchambuzi...",
      "analyticsError": "Hitilafu ya kupakia uchambuzi",
      "retry": "Jaribu tena kupakia",
      "workbench": {
        "contextHint": "Utambulisho wa fomu, ukusanyaji, ratiba ya matukio na AI kwa kipindi kimoja kinachoshirikiwa (7 / 30 / all).",
        "completionBadge": "Ukamilifu {rate}%",
        "metaVersion": "v{version}",
        "metaPublished": "chap. {date}",
        "metaUpdated": "sas. {date}",
        "summaryTitle": "Muhtasari wa ukusanyaji",
        "sections": {
          "metadata": {
            "title": "Utambulisho wa fomu",
            "xmlFormId": "Kitambulisho cha XML",
            "version": "Toleo",
            "published": "Imechapishwa",
            "updated": "Imesasishwa mwisho"
          },
          "intake": {
            "title": "Muhtasari wa ukusanyaji",
            "subtitle": "Mawasilisho ya leo, wiki hii na jumla"
          },
          "quickLinks": {
            "title": "Viungo vya haraka"
          },
          "agent": {
            "title": "Msaidizi wa AI",
            "subtitle": "Muhtasari, ripoti za uchambuzi au mazungumzo kuhusu fomu hii"
          },
          "timeline": {
            "title": "Mstari wa muda wa mawasilisho",
            "subtitle": "Kiasi cha kila siku katika kipindi kilichochaguliwa"
          },
          "map": {
            "title": "Usambazaji wa kijiografia",
            "subtitle": "Maeneo ya mawasilisho yenye data ya geo"
          }
        },
        "metrics": {
          "noChange": "Hakuna mabadiliko"
        },
        "intakeStrip": {
          "ariaLabel": "Hali ya ukusanyaji wa data",
          "today": "Leo",
          "todayDelta": "{delta} dhidi ya jana",
          "todayFlat": "Sawa na jana",
          "week": "Wiki hii",
          "weekDelta": "{delta} dhidi ya wiki iliyopita",
          "weekFlat": "Sawa na wiki iliyopita",
          "total": "Jumla ya majibu",
          "totalHint": "Jumla iliyokusanywa kwa fomu hii",
          "totalEmpty": "Bado hakuna majibu"
        }
      },
      "cards": {
        "totalSubmissions": {
          "title": "Jumla ya Mawasilisho",
          "today": "leo"
        },
        "completedSubmissions": {
          "title": "Mawasilisho Yaliyokamilika",
          "rate": "kiwango cha kukamilisha"
        },
        "dataCollectors": {
          "title": "Wakusanyaji wa Data",
          "new": "mpya"
        },
        "problematicSubmissions": {
          "title": "Mawasilisho Yanayoshida"
        },
        "submissionTimeline": {
          "title": "Muda wa Mawasilisho",
          "totalForPeriod": "Jumla ya kipindi",
          "noData": "Hakuna data ya muda wa mawasilisho",
          "noSubmissionsInPeriod": "Hakuna mawasilisho kwa kipindi kilichochaguliwa",
          "stats": {
            "totalSubmissions": "Jumla ya mawasilisho",
            "maxPerDay": "Upeo kwa siku",
            "trend": "Mwelekeo"
          },
          "timeframes": {
            "7days": "Siku 7 za mwisho",
            "30days": "Siku 30 za mwisho",
            "90days": "Siku 90 za mwisho"
          },
          "trend": {
            "stable": "Hakuna mabadiliko",
            "growth": "Ukuaji",
            "decline": "Kupungua"
          },
          "hint": "Bofya kwenye bar ili kuona maelezo ya siku"
        }
      }
    },
    "summaryCard": {
      "id": "Kitambulisho",
      "statusNotSet": "Hali haijabainishwa",
      "statusDescriptions": {
        "published": "Fomu imefunguliwa kwa ukusanyaji wa data",
        "closing": "Fomu inafungwa, majibu mapya yamezuiliwa",
        "closed": "Fomu imefungwa, majibu mapya hayakubaliwi",
        "draft": "Fomu iko katika hali ya rasimu, haijachapishwa",
        "unknown": "Hali haijulikani"
      },
      "stats": {
        "today": "Leo",
        "week": "Wiki hii",
        "total": "Jumla iliyokusanywa",
        "responses": "majibu ya fomu",
        "fromYesterday": "kutoka jana",
        "fromLastWeek": "kutoka wiki iliyopita"
      },
      "info": {
        "version": "Toleo",
        "notSpecified": "Haijabainishwa",
        "created": "Imeundwa",
        "updated": "Imehakikiwa",
        "notUpdated": "Haijahakikiwa",
        "published": "Imechapishwa",
        "notPublished": "Haijachapishwa",
        "notSpecifiedDate": "Haijabainishwa"
      },
      "trend": {
        "title": "Mwelekeo wa kujaza siku 7 za mwisho",
        "noData": "Hakuna data",
        "growth": "Ukuaji",
        "decline": "Kupungua",
        "stable": "Hakuna mabadiliko"
      }
    },
    "attachments": {
      "title": "Vifungo vya fomu",
      "formLabel": "Fomu:",
      "noAttachmentsRequired": "Hakuna vifungo vinavyohitajika",
      "noAttachmentsDescription": "Fomu hii haijumuishi marejeleo ya faili za nje (picha, hati, n.k.).",
      "noAttachmentsHint": "Ukiongeza marejeleo ya faili katika XLSForm, yataonekana hapa kiotomatiki.",
      "uploadSection": {
        "supportedFormats": "Miundo inayoungwa mkono:",
        "dropZoneTitles": {
          "uploadMissing": "Pakia faili zisizopo",
          "updateExisting": "Sasisha faili zilizopo",
          "uploadFiles": "Pakia faili"
        },
        "dropZoneDescriptions": {
          "uploadMissing": "Inatarajiwa {count} faili: {files}",
          "updateExisting": "Faili zote zimepakwa. Unaweza kuzibadilisha na matoleo mapya.",
          "uploadFiles": "Chagua faili za kupakia vifungo vya fomu."
        },
        "dropZoneButtons": {
          "selectFiles": "Chagua faili",
          "updateFiles": "Sasisha faili",
          "chooseFiles": "Chagua faili"
        },
        "selectedFiles": "Faili zilizochaguliwa ({count})",
        "uploadButton": "Pakia {count} faili",
        "uploading": "Inapakia...",
        "clear": "Safisha",
        "chooseFiles": "Chagua faili"
      },
      "table": {
        "columns": {
          "name": "Jina la faili",
          "status": "Hali",
          "type": "Aina",
          "size": "Ukubwa",
          "updatedAt": "Tarehe ya kupakia",
          "actions": "Vitendo"
        },
        "status": {
          "uploaded": "Imepakwa",
          "missing": "Haipo",
          "deleted": "Imefutwa",
          "unknown": "Haijulikani"
        },
        "actions": {
          "download": "Pakua",
          "delete": "Futa",
          "deleted": "Imefutwa",
          "missing": "Haipo"
        },
        "notSpecified": "Haijaspecifikwa"
      },
      "messages": {
        "uploadSuccess": "Imepakwa kwa mafanikio {count} faili",
        "uploadError": "Hitilafu ya kupakia faili: {error}",
        "fileNotFound": "Faili {filename} haijapatikana katika faili zilizochaguliwa",
        "fileUploadSuccess": "Faili {filename} imepakwa kwa mafanikio",
        "fileUploadError": "Hitilafu ya kupakia faili {filename}: {error}",
        "downloadError": "Hitilafu ya kupakua faili {filename}: {error}",
        "deleteSuccess": "Faili {filename} imefutwa kwa mafanikio",
        "deleteError": "Hitilafu ya kufuta faili {filename}: {error}",
        "invalidFilesIgnored": "Faili zifuatazo zitaachwa (hazijapatikana katika orodha inayotarajiwa): {files}",
        "filesWillBeUpdated": "Faili zifuatazo zitasasishwa: {files}",
        "loadingError": "Hitilafu ya kupakia vifungo",
        "downloadSuccess": "Faili {filename} imepakua kwa mafanikio",
        "fileAlreadyDeleted": "Faili {filename} tayari imefutwa au haipo",
        "fileNotInExpectedList": "Faili haijapatikana katika orodha ya vifungo vinavyotarajiwa"
      },
      "confirmDelete": {
        "title": "Thibitisha ufutaji",
        "message": "Je, una uhakika unataka kufuta faili \"{filename}\"?",
        "warning": "Kitendo hiki hakiwezi kubatilishwa.",
        "deleting": "Inafuta...",
        "delete": "Futa"
      }
    }
  },
  "pageNotFound": {
    "title": "Lo! Ukurasa haukupatikana.",
    "subtitle": "404",
    "description": "Ukurasa unaotafuta haupo au umehamishwa.",
    "goBack": "Rudi nyuma",
    "goHome": "Nenda ukurasa wa nyumbani",
    "copyright": "© {year} UDACAPI. Haki zote zimehifadhiwa."
  },
  "maps": {
    "tabTitle": "Ramani",
    "pageTitle": "Ramani ya Mradi",
    "subtitle": "Fuatilia ukusanyaji wa data wenye GPS kwa wakati halisi",
    "empty": {
      "noGeoForms": "Hakuna fomu katika mradi huu yenye maswali ya GPS bado.",
      "noPoints": "Hakuna mawasilisho yanayolingana na vichujio vya sasa."
    },
    "filters": {
      "title": "Vichujio",
      "forms": "Fomu",
      "dateFrom": "Kuanzia",
      "dateTo": "Hadi",
      "qcStatus": "Hali ya QC",
      "enumerator": "Mdadisi",
      "heatmap": "Ramani ya joto",
      "reset": "Anzisha upya vichujio",
      "apply": "Tumia"
    },
    "qcStatuses": {
      "any": "Yoyote",
      "pass": "Imepita",
      "fail": "Imeshindwa",
      "warning": "Onyo",
      "error": "Hitilafu",
      "none": "Haijathibitishwa"
    },
    "actions": {
      "export": "Hamisha GeoJSON",
      "refresh": "Onyesha upya",
      "settings": "Mipangilio ya ramani",
      "openSubmission": "Fungua uwasilishaji",
      "openFormOnMap": "Tazama fomu kwenye ramani"
    },
    "popup": {
      "submittedAt": "Imewasilishwa",
      "submittedBy": "Imewasilishwa na",
      "form": "Fomu",
      "status": "Hali ya QC"
    },
    "truncated": "Inaonyesha pointi za kwanza {limit}. Punguza vichujio au washa mkusanyiko ili kuona zaidi.",
    "settingsDialog": {
      "title": "Mipangilio ya ramani ya mradi",
      "defaultCenter": "Kitovu chaguomsingi",
      "defaultCenterHint": "Bonyeza ramani ili kuchagua eneo",
      "defaultZoom": "Kuza chaguomsingi",
      "defaultForms": "Fomu za chaguomsingi",
      "heatmapDefault": "Onyesha ramani ya joto kwa chaguomsingi",
      "coordinateFields": "Sehemu za kuratibu",
      "latitudeField": "Sehemu ya latitudo",
      "longitudeField": "Sehemu ya longitudo",
      "automaticDetection": "Tumia utambuzi wa kiotomatiki",
      "coordinateSourceTitle": "Chanzo cha kuratibu",
      "coordinateMode": "Hali ya kuratibu",
      "modeAuto": "Utambuzi wa kiotomatiki",
      "modeNone": "Hakuna data ya eneo",
      "modeLatLon": "Sehemu za latitudo na longitudo",
      "modeGeopoint": "Sehemu ya geopoint",
      "geopointField": "Sehemu ya geopoint",
      "detectedSource": "Chanzo kilichotambuliwa: {path} · pointi sasa: {count}",
      "configureCoordinates": "Sehemu za kuratibu",
      "noMapHint": "Hakuna pointi za ramani kwa fomu hii. Sanidi sehemu za kuratibu ikiwa mawasilisho yana maeneo.",
      "save": "Hifadhi",
      "cancel": "Ghairi",
      "saved": "Mipangilio imehifadhiwa"
    },
    "savedViews": {
      "title": "Mionekano iliyohifadhiwa",
      "noViewsYet": "Hakuna mionekano iliyohifadhiwa — unda kwenye ramani ya mradi",
      "recommended": "Inayopendekezwa",
      "defaultLabel": "chaguo-msingi",
      "saveHint": "Baada ya Tumia, ramani inatumia vichujio na ramani ya joto. «Hifadhi mwonekano wa sasa» huhifadhi mpangilio huu kwa jina (wasimamizi wa mradi tu).",
      "saveCurrent": "Hifadhi mwonekano wa sasa",
      "updateCurrent": "Sasisha mwonekano",
      "delete": "Futa mwonekano",
      "name": "Jina la mwonekano",
      "pinAsDefault": "Weka kama chaguomsingi",
      "pin": "Bandika mwonekano",
      "saved": "Mwonekano umehifadhiwa",
      "updated": "Mwonekano umesasishwa",
      "deleted": "Mwonekano umefutwa",
      "saveFailed": "Hakuna mwonekano iliyohifadhiwa — unda kwenye ramani ya mradi.",
      "updateFailed": "Haikuweza kusasisha mwonekano.",
      "deleteFailed": "Haikuweza kufuta mwonekano."
    },
    "tileConfig": {
      "sectionTitle": "Seva ya vigae vya ramani",
      "sectionDescription": "Weka URL maalum ya seva ya vigae kwa shirika lako. Acha tupu kutumia vigae vya umma vya OpenStreetMap.",
      "url": "Kiolezo cha URL cha vigae",
      "urlPlaceholder": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      "attribution": "Sifa",
      "subdomains": "Vikoa vidogo",
      "maxZoom": "Kuza upeo",
      "minZoom": "Kuza chini",
      "test": "Jaribu URL",
      "configure": "Sanidi",
      "edit": "Hariri",
      "defaultTiles": "Inatumia vigae vya umma vya OpenStreetMap",
      "zoom": "Kuza",
      "clear": "Futa",
      "save": "Hifadhi",
      "saved": "Mipangilio ya vigae imehifadhiwa",
      "cleared": "Seva maalum ya vigae imefutwa"
    }
  },
  "help": {
    "title": "Msaada",
    "subtitle": "Miongozo mifupi na majibu kwa kazi za kawaida za UDACAPI.",
    "searchPlaceholder": "Tafuta miongozo na maswali…",
    "learnMore": "Jifunze zaidi",
    "openGuide": "Fungua",
    "openGuideFormScope": "Fungua dashibodi — kisha chagua mradi na fomu",
    "whenToUse": "Lini utumie",
    "steps": "Hatua",
    "comingSoon": "Miongozo zaidi ya uchambuzi, ufuatiliaji na mipangilio ya shirika inakuja hivi karibuni.",
    "noResults": "Hakuna miongozo inayolingana na utafutaji wako.",
    "featureGuides": {
      "odkServers": {
        "title": "Seva za ODK",
        "summary": "Unganisha seva yako ya ODK Central (au inayolingana) ili UDACAPI iweze kusawazisha miradi na uwasilishaji.",
        "whenToUse": "Usanidi wa kwanza, kabla ya kusawazisha au kuagiza.",
        "steps": [
          "Fungua Seva za ODK kwenye upau wa pembeni.",
          "Ongeza URL ya seva na hati za uthibitisho.",
          "Endesha Jaribu muunganisho.",
          "Rekebisha URL, hati za uthibitisho au matatizo ya mtandao kabla ya kusawazisha."
        ]
      },
      "sync": {
        "title": "Sync Workbench",
        "summary": "Vuta uwasilishaji mpya na sasisha muundo wa fomu kutoka ODK.",
        "whenToUse": "Baada ya seva kuunganishwa; unapotarajia data mpya ya uwanja.",
        "steps": [
          "Fungua Sync Workbench.",
          "Chagua seva, mradi na fomu.",
          "Kagua kishale cha kusawazisha na hali ya usawazishaji wa mwisho.",
          "Anza usawazishaji na subiri ukamilike.",
          "Fungua fomu — Overview, Export au QC."
        ]
      },
      "import": {
        "title": "Agiza miradi na fomu",
        "summary": "Leta miradi na fomu za ODK zilizopo kwenye shirika lako.",
        "whenToUse": "Uhamiaji kutoka ODK au kuanzisha seva mpya.",
        "steps": [
          "Hakikisha seva ya ODK imeunganishwa na kujaribiwa.",
          "Kutoka Miradi, anza Agiza (seva za shirika pekee).",
          "Chagua mradi na agiza fomu.",
          "Fungua fomu na thibitisha Overview na Settings."
        ]
      },
      "xlsformAssist": {
        "title": "XLSForm Assist",
        "summary": "Workbench ya AI kwa kuandika rasimu, kuhakiki na kuchapisha mabadiliko ya XLSForm.",
        "whenToUse": "Tafiti mpya au mabadiliko makubwa ya muundo.",
        "steps": [
          "Fungua mradi na uzindue XLSForm Assist.",
          "Elezea utafiti au pakia faili ya maswali.",
          "Kagua hakiki ya ODK Web Forms.",
          "Thibitisha uchapishaji na subiri kazi ikamilike."
        ]
      },
      "formOverview": {
        "title": "Form Overview",
        "summary": "Muhtasari wa ukusanyaji, ratiba ya matukio, ramani na maswali na majibu ya AI kwa kipindi kilichochaguliwa.",
        "whenToUse": "Ufuatiliaji wa kila siku; maswali ya haraka kuhusu data hai ya fomu.",
        "steps": [
          "Fungua fomu na nenda Overview.",
          "Chagua kipindi (7 / 30 / all) — kinashirikiwa na ripoti za AI na ratiba ya matukio.",
          "Kagua ratiba ya matukio na ramani.",
          "Tumia mazungumzo ya AI au tengeneza ripoti za muhtasari kwa dirisha lile lile."
        ]
      },
      "autoReports": {
        "title": "Ripoti za kiotomatiki",
        "summary": "Ripoti za AI zilizopangwa na kwa mahitaji kwa kila fomu na utoaji kwa email.",
        "whenToUse": "Masasisho ya mara kwa mara kwa wadau (kila wiki au kila mwezi).",
        "steps": [
          "Org → Violezo vya ripoti — unda au chagua kiolezo.",
          "Fomu → Ripoti za kiotomatiki — weka ratiba na wapokeaji.",
          "Tumia Generate kwa hakiki ya mkono na kipindi.",
          "Tumia Send kutoa baada ya hakiki."
        ]
      },
      "qc": {
        "title": "Udhibiti wa ubora (QC)",
        "summary": "Sheria za uthibitishaji kwenye uwasilishaji; AI inaweza kupendekeza kifurushi cha kuanzia.",
        "whenToUse": "Baada ya uwasilishaji wa kwanza; kabla ya kuamini uhamishaji au uchambuzi.",
        "steps": [
          "Fungua fomu na nenda QC.",
          "Unda sheria au tumia pendekezo la AI.",
          "Endesha uthibitishaji.",
          "Kagua uwasilishaji ulioalamishwa."
        ]
      },
      "export": {
        "title": "Uhamishaji wa data",
        "summary": "Hamisha uwasilishaji kwa CSV, Excel na zaidi; fomu kubwa hutumia kazi za async.",
        "whenToUse": "Uhamisho kwa Excel, SPSS, Stata au mifumo ya nje.",
        "steps": [
          "Fungua fomu na nenda Data Export.",
          "Chagua muundo na chaguo.",
          "Anza uhamishaji na subiri kazi.",
          "Pakua faili kutoka orodha ya kazi."
        ]
      }
    },
    "faq": {
      "title": "Maswali yanayoulizwa mara kwa mara",
      "items": {
        "sync-no-new-data": {
          "question": "Kwa nini usawazishaji hauvuti uwasilishaji mpya?",
          "answer": "Angalia kwamba seva ya ODK inapatikana, kishale cha kusawazisha hakikwamishwa kwenye nafasi ya zamani, umechagua fomu sahihi na akaunti yako inaweza kufikia mradi huo. Endesha Jaribu muunganisho kwenye seva, kisha jaribu tena kusawazisha kutoka Sync Workbench."
        },
        "sync-cursor": {
          "question": "Kishale cha kusawazisha ni nini?",
          "answer": "Kishale ni kiashiria cha usawazishaji wa hatua kwa hatua — mahali UDACAPI ilisimamisha kusoma uwasilishaji mara ya mwisho. Kuweka upya au kupotosha vishale kunaweza kuruka au kuvuta tena data; tumia Sync Workbench kukagua hali ya kishale kabla ya kulazimisha usawazishaji kamili tena."
        },
        "import-server-type": {
          "question": "Kwa nini siwezi kuagiza kutoka seva hii?",
          "answer": "Uagizaji wa mradi unaruhusiwa tu kwenye seva za ODK za shirika. Seva za Shared na Global haziwezi kutumika kwa uagizaji — unganisha seva ya org au wasiliana na msimamizi wako."
        },
        "import-how": {
          "question": "Ninawezaje kuagiza mradi wa ODK uliopo?",
          "answer": "Unganisha na ujaribu seva, kisha nenda Miradi → Agiza, chagua mradi na agiza fomu. Tazama mwongozo Agiza miradi na fomu hapo juu kwa maelekezo hatua kwa hatua."
        },
        "xlsform-where": {
          "question": "XLSForm Assist iko wapi?",
          "answer": "Fungua mradi kutoka Miradi, kisha uzindue XLSForm Assist kutoka eneo la fomu za mradi (au njia maalum ya assist kwa mradi huo)."
        },
        "ai-scope": {
          "question": "AI ya fomu inaweza kujibu nini?",
          "answer": "Maswali kuhusu muundo wa fomu, uwasilishaji, uchambuzi, sheria za QC na hali ya usawazishaji — kulingana na data hai ya fomu hiyo. Haiibadili uthibitishaji wa QC au ukaguzi wa kisheria wa data ya kibinafsi."
        },
        "ai-quota": {
          "question": "Kwa nini naona kiasi kimezidi?",
          "answer": "Shirika lako limefikia kikomo cha matumizi ya agent. Subiri dirisha la kuweka upya au wasiliana na mmiliki au msimamizi wa shirika ili kurekebisha vikomo."
        },
        "auto-generate-vs-schedule": {
          "question": "Tofauti kati ya Generate na ripoti iliyopangwa ni ipi?",
          "answer": "Generate inaendeshwa kwa mahitaji kwa kipindi unachochagua kwenye fomu. Uendeshaji uliopangwa hufuata cron ya kiolezo na hutumia dirisha la data linalolingana na ratiba — si lazima lile lile na kichaguzi cha kipindi cha Overview."
        },
        "auto-templates": {
          "question": "Violezo vya ripoti vinadhibitiwa wapi?",
          "answer": "Kiwango cha shirika: Shirika Langu → Violezo vya ripoti (au kiungo cha haraka cha violezo). Violezo viko katikati ya org; kichupo cha Ripoti za kiotomatiki cha kila fomu kinaonyesha violezo vinavyohusisha fomu hiyo."
        },
        "qc-first-rule": {
          "question": "Ninawezaje kuunda sheria yangu ya kwanza ya QC?",
          "answer": "Fungua fomu → QC → Unda sheria, au tumia pendekezo la AI kuandika kifurushi cha kuanzia kutoka muundo wa fomu, kisha endesha uthibitishaji."
        },
        "export-slow": {
          "question": "Uhamishaji unachukua muda mrefu — je, hii ni kawaida?",
          "answer": "Ndiyo kwa fomu kubwa. Uhamishaji unaendeshwa kama kazi za mandharinyuma. Weka ukurasa wazi au rudi Data Export kupakua kazi inapokamilika."
        },
        "export-where": {
          "question": "Faili yangu iliyohamishwa iko wapi?",
          "answer": "Kwenye kichupo cha Data Export cha fomu — kwenye orodha ya kazi/historia na kitendo cha kupakua hali ya kazi ni complete."
        },
        "permissions-missing": {
          "question": "Sioni mradi au kichupo",
          "answer": "Kikundi chako cha ruhusa kinaweza kisijumuishwe mradi au kipengele hicho. Muombe mmiliki wa shirika akague vikundi vya ruhusa na ufikiaji wa miradi."
        }
      }
    },
    "support": {
      "title": "Unahitaji msaada zaidi?",
      "body": "Wasiliana na usaidizi wa UDACAPI ikiwa miongozo hii haitatui tatizo lako.",
      "contactLabel": "Tuma email kwa usaidizi"
    }
  }
}
